"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataTemplate = void 0;
var outline_1 = require("@heroicons/react/24/outline");
var solid_1 = require("@heroicons/react/24/solid");
var moment_1 = __importDefault(require("moment"));
var react_1 = __importStar(require("react"));
var uuid_1 = require("uuid");
var button_1 = require("../../action/button");
var iconButton_1 = require("../../action/iconButton");
var textButton_1 = require("../../action/textButton");
var popUp_1 = require("../../advanced/popUp");
var detailList_1 = require("../../display/detailList");
var emptyState_1 = require("../../display/emptyState");
var grid_1 = require("../../display/grid");
var list_1 = require("../../display/list");
var loading_1 = require("../../display/loading");
var modal_1 = require("../../display/modal");
var notification_1 = require("../../display/notification");
var stepper_1 = require("../../display/stepper");
var table_1 = require("../../display/table");
var datePicker_1 = require("../../input/datePicker");
var form_1 = require("../../input/form");
var select_1 = require("../../input/select");
var textInput_1 = require("../../input/textInput");
var uploadInput_1 = require("../../input/uploadInput");
var breadcrumb_1 = require("../../navigation/breadcrumb");
var tabs_1 = require("../../navigation/tabs");
var link_1 = require("../../structure/link");
var display_1 = require("../display");
var queryForm_1 = require("../queryForm");
var readQueryHoc_1 = require("../readQueryHoc");
var utils_1 = require("../utils");
var writeQuery_1 = require("../writeQuery");
var settingsModal_1 = require("./settingsModal");
var queryTableHeader = [
    {
        key: "name",
        title: "Column",
    },
    {
        key: "value",
        title: "Value",
    },
    {
        key: "sort",
        title: "Sort",
    },
    {
        key: "view",
        title: "View",
    },
    {
        key: "del",
        title: "Delete",
    },
];
function DataTemplate(props) {
    var _this = this;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    var formRef = (0, react_1.createRef)();
    var objectFormRef = (0, react_1.createRef)();
    var modalFormInputRefs = props.model.map(function () { return (0, react_1.createRef)(); });
    var batchUpdateFormRef = (0, react_1.createRef)();
    var batchUpdateColumnIdRef = (0, react_1.createRef)();
    var batchUpdateInputRef = (0, react_1.createRef)();
    var limit = props.limit ? props.limit : 10;
    var readQueryHocRef = (0, react_1.useRef)();
    var typingTimeout = (0, react_1.useRef)();
    var _o = (0, react_1.useState)(false), loading = _o[0], setLoading = _o[1];
    var _p = (0, react_1.useState)(), notification = _p[0], setNotification = _p[1];
    //INFO : Used by List
    var _q = (0, react_1.useState)(""), filterSearch = _q[0], setFilterSearch = _q[1];
    var _r = (0, react_1.useState)(""), filterSearchParams = _r[0], setFilterSearchParams = _r[1];
    var _s = (0, react_1.useState)(""), filterSelection = _s[0], setFilterSelection = _s[1];
    var _t = (0, react_1.useState)(""), filterReference = _t[0], setFilterReference = _t[1];
    var _u = (0, react_1.useState)(""), filterReferenceSearch = _u[0], setFilterReferenceSearch = _u[1];
    var _v = (0, react_1.useState)([]), filterReferenceList = _v[0], setFilterReferenceList = _v[1];
    var _w = (0, react_1.useState)({
        startDate: undefined,
        endDate: undefined,
    }), filterReferenceDate = _w[0], setFilterReferenceDate = _w[1];
    var _x = (0, react_1.useState)(true), tableLoading = _x[0], setTableLoading = _x[1];
    var _y = (0, react_1.useState)(""), cursor = _y[0], setCursor = _y[1];
    var _z = (0, react_1.useState)(""), lastCursor = _z[0], setLastCursor = _z[1];
    var _0 = (0, react_1.useState)([]), tableData = _0[0], setTableData = _0[1];
    var _1 = (0, react_1.useState)([]), spaceTableData = _1[0], setSpaceTableData = _1[1];
    var _2 = (0, react_1.useState)(0), size = _2[0], setSize = _2[1];
    var _3 = (0, react_1.useState)(0), pageIndex = _3[0], setPageIndex = _3[1];
    var _4 = (0, react_1.useState)([]), selectedIds = _4[0], setSelectedIds = _4[1];
    var _5 = (0, react_1.useState)(false), selectAll = _5[0], setSelectAll = _5[1];
    var _6 = (0, react_1.useState)(""), deletePasscode = _6[0], setDeletePasscode = _6[1];
    var _7 = (0, react_1.useState)(""), deletePasscodeInput = _7[0], setDeletePasscodeInput = _7[1];
    //INFO : Used by List Organise
    var _8 = (0, react_1.useState)(false), sortModal = _8[0], setSortModal = _8[1];
    var _9 = (0, react_1.useState)(false), filterModal = _9[0], setFilterModal = _9[1];
    var _10 = (0, react_1.useState)(false), addTabModal = _10[0], setAddTabModal = _10[1];
    var _11 = (0, react_1.useState)(false), queryForm = _11[0], setQueryForm = _11[1];
    var _12 = (0, react_1.useState)(false), batchUpdateModal = _12[0], setBatchUpdateModal = _12[1];
    var _13 = (0, react_1.useState)({
        columnId: "",
        columnData: {},
    }), batchUpdateData = _13[0], setBatchUpdateData = _13[1];
    //INFO : Used by Export
    var _14 = (0, react_1.useState)(null), csvFile = _14[0], setCSVFile = _14[1];
    var _15 = (0, react_1.useState)([]), csvFileData = _15[0], setCSVFileData = _15[1];
    var _16 = (0, react_1.useState)(0), stepCSVIndex = _16[0], setStepCSVIndex = _16[1];
    var _17 = (0, react_1.useState)({}), listCSVMapAttribute = _17[0], setListCSVMapAttribute = _17[1];
    var _18 = (0, react_1.useState)({}), listCSVObjAttribute = _18[0], setListCSVObjAttribute = _18[1];
    var _19 = (0, react_1.useState)([]), csvAPIAttribute = _19[0], setCSVAPIAttribute = _19[1];
    var _20 = (0, react_1.useState)([]), importTableData = _20[0], setImportTableData = _20[1];
    var _21 = (0, react_1.useState)(""), exportLink = _21[0], setExportLink = _21[1];
    var _22 = (0, react_1.useState)([]), queryList = _22[0], setQueryList = _22[1];
    var _23 = (0, react_1.useState)(-1), queryIndex = _23[0], setQueryIndex = _23[1];
    //INFO : Used by Read
    //INFO : Used by Update
    var _24 = (0, react_1.useState)(false), modalVisible = _24[0], setModalVisible = _24[1];
    var _25 = (0, react_1.useState)(false), deleteModal = _25[0], setDeleteModal = _25[1];
    var _26 = (0, react_1.useState)(false), excelModal = _26[0], setExcelModal = _26[1];
    var _27 = (0, react_1.useState)(false), exportExcel = _27[0], setExportExcel = _27[1];
    var _28 = (0, react_1.useState)({}), selectedData = _28[0], setSelectedData = _28[1];
    var _29 = (0, react_1.useState)(""), selectedObjectStructureId = _29[0], setSelectedObjectStructureId = _29[1];
    var _30 = (0, react_1.useState)(""), selectedObjectId = _30[0], setSelectedObjectId = _30[1];
    var _31 = (0, react_1.useState)({}), selectedObjectData = _31[0], setSelectedObjectData = _31[1];
    var _32 = (0, react_1.useState)(false), referenceLoading = _32[0], setReferenceLoading = _32[1];
    var _33 = (0, react_1.useState)({}), referencesOptions = _33[0], setReferencesOptions = _33[1];
    var _34 = (0, react_1.useState)({}), referenceModelSchema = _34[0], setReferenceSchema = _34[1];
    var devSettings = props.devSettings;
    var serverId = devSettings.server === "mongoServer" ? "_id" : "id";
    var isEditor = ((_a = props.edit) === null || _a === void 0 ? void 0 : _a.allEditable) ? true : false;
    var dbModule = devSettings.server === "firebase" ? (_b = props.lib) === null || _b === void 0 ? void 0 : _b.firebase : (_c = props.lib) === null || _c === void 0 ? void 0 : _c.axios;
    var writeServerQuery = new writeQuery_1.WriteQuery({
        dbModule: (_d = props.lib) === null || _d === void 0 ? void 0 : _d.axios,
        dbType: devSettings.server,
        dbCollection: props.collectionId,
        dbEndpoint: devSettings.dbEndpoint,
    });
    var debug = ((_e = props.organise) === null || _e === void 0 ? void 0 : _e.debugOnChangeType) ? true : false;
    var moreButtonPopUp = [
        {
            text: "Import Excel",
            onClick: function () {
                setExcelModal(true);
                setModalVisible(true);
            },
        },
        {
            text: "Export Excel",
            onClick: function () {
                setExportExcel(true);
                setModalVisible(true);
            },
        },
    ];
    if ((_f = props.organise) === null || _f === void 0 ? void 0 : _f.moreSettings)
        moreButtonPopUp = moreButtonPopUp.concat(props.organise.moreSettings);
    (0, react_1.useEffect)(function () {
        switch (props.type) {
            case "read":
            case "update":
                setReferencesOptions({});
                setExcelModal(false);
                setExportExcel(false);
                setSelectedData({});
                setSelectedObjectData({});
                if (props.id !== "new" && props.id !== "") {
                    setModalVisible(true);
                    setLoading(true);
                    if (readQueryHocRef.current)
                        readQueryHocRef.current.handleRefresh();
                }
                break;
            case "list":
                setReferencesOptions({});
                break;
        }
    }, [props.type, props.id]);
    //=====================================================================================
    //SECTION: Handle List
    //=====================================================================================
    var handleSelectIds = function (selectedIds) {
        setSelectedIds(selectedIds);
    };
    var handleSelectAllPages = function (value) {
        setSelectAll(value);
    };
    var handlePagination = function (value) {
        if (devSettings.server === "mongoServer") {
            setTableLoading(true);
            setTableData([]);
            setSpaceTableData([]);
        }
        if (typeof value === "number") {
            setPageIndex(value);
        }
        else {
            if (value === "next") {
                //INFO : Retrieve latest cursor data from Firebase only
                if (devSettings.server !== "mongoServer" &&
                    cursor &&
                    (pageIndex + 1) * limit + 1 > tableData.length) {
                    setLastCursor(cursor);
                }
                setPageIndex(pageIndex + 1);
            }
            else {
                setPageIndex(pageIndex - 1);
            }
        }
    };
    var handleGetListData = function (responseData, type, rowId) { return __awaiter(_this, void 0, void 0, function () {
        var dataList, prettierDataList, selectedIndex_1;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        return __generator(this, function (_m) {
            switch (_m.label) {
                case 0:
                    dataList = [];
                    prettierDataList = [];
                    if (!responseData) return [3 /*break*/, 2];
                    return [4 /*yield*/, (0, display_1.handleListDataBasedOnModel)(responseData.data, (_b = (_a = props.devSettings) === null || _a === void 0 ? void 0 : _a.server) !== null && _b !== void 0 ? _b : "mongoServer", (_c = props.lib) === null || _c === void 0 ? void 0 : _c.axios, props.model, (_e = (_d = props.devSettings) === null || _d === void 0 ? void 0 : _d.imageEndpoint) !== null && _e !== void 0 ? _e : "", props.localURLEndpoint, props.collectionId, (_g = (_f = props.devSettings) === null || _f === void 0 ? void 0 : _f.dbEndpoint) !== null && _g !== void 0 ? _g : "", (_h = props.devSettings.organisationMembers) !== null && _h !== void 0 ? _h : [], handleNavigate, (_j = props.devSettings) === null || _j === void 0 ? void 0 : _j.bucketName, ((_k = props.organise) === null || _k === void 0 ? void 0 : _k.viewId) === "general", (_l = props.organise) === null || _l === void 0 ? void 0 : _l.debugOnChangeType)];
                case 1:
                    prettierDataList = _m.sent();
                    responseData.data.map(function (eachData) {
                        if (eachData["_id"]) {
                            eachData["id"] = eachData["_id"];
                            delete eachData["_id"];
                        }
                        return null;
                    });
                    dataList = responseData.data;
                    _m.label = 2;
                case 2:
                    if (type === "update" || type === "create") {
                        try {
                            if (type === "update") {
                                selectedIndex_1 = -1;
                                tableData.map(function (eachData, index) {
                                    if (eachData.id === rowId)
                                        selectedIndex_1 = index;
                                    return null;
                                });
                                if (selectedIndex_1 > -1) {
                                    tableData[selectedIndex_1] = responseData.data[0];
                                    spaceTableData[selectedIndex_1] = prettierDataList[0];
                                }
                            }
                            else {
                                tableData.push(responseData.data[0]);
                                spaceTableData.push(prettierDataList[0]);
                            }
                            setTableData(tableData);
                            setSpaceTableData(spaceTableData);
                        }
                        catch (err) { }
                    }
                    else {
                        if (devSettings.server === "mongoServer") {
                            setTableData(dataList);
                            setSpaceTableData(prettierDataList);
                            setSize(responseData.count);
                        }
                        else {
                            setTableData(filterSearchParams ? dataList : dataList.concat(tableData));
                            setSpaceTableData(filterSearchParams
                                ? dataList
                                : spaceTableData.concat(prettierDataList));
                            setCursor(responseData.count);
                        }
                    }
                    setTableLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleRefresh = function (open) {
        setTimeout(function () {
            handleClearDataByFilter();
            setSelectedIds([]);
        }, 250);
        setTimeout(function () {
            setLoading(false);
            if (!open) {
                setModalVisible(false);
                setDeleteModal(false);
                setBatchUpdateModal(false);
                handlePopUpModal(false);
            }
            if (readQueryHocRef.current)
                readQueryHocRef.current.handleRefresh();
        }, 500);
    };
    var handleClearDataByFilter = function () {
        setTableData([]);
        setSpaceTableData([]);
        setPageIndex(0);
        setTableLoading(true);
    };
    var handleNameSearch = function (e) {
        setFilterSearch(e.target.value);
        handleClearDataByFilter();
        if (typingTimeout.current) {
            clearTimeout(typingTimeout.current);
            typingTimeout.current = null;
        }
        typingTimeout.current = setTimeout(function () {
            setFilterSearchParams(e.target.value);
        }, 500);
    };
    var handleRangeFilterOnChange = function (id, value, type) {
        var clonedRageFilter = JSON.parse(JSON.stringify(filterReferenceDate));
        clonedRageFilter[id] =
            type === "start" ? value : filterReferenceDate.startDate;
        clonedRageFilter["endDate"] =
            type === "end" ? value : filterReferenceDate.endDate;
        setFilterReferenceDate(clonedRageFilter);
    };
    var handleGetItemError = function (err) {
        var _a;
        setTableLoading(false);
        setModalVisible(false);
        setLoading(false);
        if (props.type === "update" || props.type === "read") {
            if ((_a = props.organise) === null || _a === void 0 ? void 0 : _a.debugOnChangeType)
                props.organise.debugOnChangeType("list", "");
            else
                handleNavigate();
        }
        else {
            console.log("Data Retrieval Error - " + err.message);
            setNotification({
                title: "Data Retrieval Error",
                type: false,
                msg: "Check console for error message",
            });
        }
    };
    //=====================================================================================
    //SECTION: Handle Object
    //=====================================================================================
    // TODO - Remove Root Folder of the Object List Image
    var handleRemoveObjectListData = function () {
        var clonedSelectedData = (0, display_1.handleClonedDataAttribute)(selectedData, props.model);
        if (selectedObjectId) {
            var index = clonedSelectedData[selectedObjectStructureId].findIndex(function (eachData) { return eachData.id === selectedObjectId; });
            if (index !== -1) {
                clonedSelectedData[selectedObjectStructureId].splice(index, 1);
            }
            setSelectedObjectId("");
            setSelectedData(clonedSelectedData);
            handlePopUpModal(false);
        }
    };
    var handleSubmitObjectDataType = function () {
        var _a, _b;
        var clonedSelectedData = (0, display_1.handleClonedDataAttribute)(selectedData, props.model);
        var filterObjectModel = props.model.find(function (eachModel) {
            return eachModel.id === selectedObjectStructureId;
        });
        var clonedSelectedObjectData = (0, display_1.handleClonedDataAttribute)(selectedObjectData, (_a = filterObjectModel === null || filterObjectModel === void 0 ? void 0 : filterObjectModel.objectData) !== null && _a !== void 0 ? _a : [], true, true);
        if (!clonedSelectedObjectData["id"]) {
            clonedSelectedObjectData["id"] = (0, uuid_1.v4)();
        }
        if ((filterObjectModel === null || filterObjectModel === void 0 ? void 0 : filterObjectModel.type) === "listObject") {
            if (selectedObjectId) {
                var index = clonedSelectedData[selectedObjectStructureId].findIndex(function (eachData) { return eachData.id === selectedObjectId; });
                if (index !== -1) {
                    clonedSelectedData[selectedObjectStructureId][index] =
                        clonedSelectedObjectData;
                }
                setSelectedObjectId("");
                setSelectedData(clonedSelectedData);
            }
            else {
                if (Array.isArray(clonedSelectedData[selectedObjectStructureId])) {
                    clonedSelectedData[selectedObjectStructureId].push(clonedSelectedObjectData);
                    setSelectedData(clonedSelectedData);
                }
                else {
                    clonedSelectedData[selectedObjectStructureId] = [
                        clonedSelectedObjectData,
                    ];
                    setSelectedData(clonedSelectedData);
                }
            }
        }
        else {
            var clonedSelectedObjectData_1 = (0, display_1.handleClonedDataAttribute)(selectedObjectData, (_b = filterObjectModel === null || filterObjectModel === void 0 ? void 0 : filterObjectModel.objectData) !== null && _b !== void 0 ? _b : []);
            clonedSelectedData[selectedObjectStructureId] = clonedSelectedObjectData_1;
            setSelectedData(clonedSelectedData);
        }
        handlePopUpModal(false);
    };
    //TODO: Bug, try to solve clicking List Object too fast
    var handleSelectListObjectData = function (id, structureId) {
        var filterObjectModel = props.model.find(function (eachModel) {
            return eachModel.id === structureId;
        });
        if ((filterObjectModel === null || filterObjectModel === void 0 ? void 0 : filterObjectModel.type) === "listObject") {
            var selectedObjectListData = selectedData[structureId].find(function (eachData) { return eachData.id === id; });
            setSelectedObjectId(id);
            setSelectedObjectStructureId(structureId);
            setSelectedObjectData(selectedObjectListData);
            setModalVisible(true);
        }
    };
    //=====================================================================================
    //SECTION: Handle Assets
    //=====================================================================================
    var handleUploadAxios = function (eachImageEndpoint, assetParentId, assetCollectionName, assetFileName, file, bucketName) { return __awaiter(_this, void 0, void 0, function () {
        var dataForm, responseData, err_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    dataForm = new FormData();
                    dataForm.append("file", file);
                    dataForm.append("data[assetCollectionName]", assetCollectionName);
                    dataForm.append("data[assetParentId]", assetParentId);
                    dataForm.append("data[assetFileName]", assetFileName);
                    if (bucketName)
                        dataForm.append("data[bucketName]", bucketName);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, ((_a = props.lib) === null || _a === void 0 ? void 0 : _a.axios({
                            method: "post",
                            url: "".concat(eachImageEndpoint, "/upload"),
                            data: dataForm,
                            headers: { "Content-Type": "multipart/form-data" },
                        }))];
                case 2:
                    responseData = _b.sent();
                    return [2 /*return*/, responseData];
                case 3:
                    err_1 = _b.sent();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleUploadImage = function (id, data) { return __awaiter(_this, void 0, void 0, function () {
        var clonedSelectedData, objectAttribute, listObjectAttribute;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    clonedSelectedData = (0, display_1.handleClonedDataAttribute)(data !== null && data !== void 0 ? data : selectedData, props.model, true);
                    return [4 /*yield*/, handleParseImageField(id, clonedSelectedData, props.model)];
                case 1:
                    //INFO: Parse & Upload Data "Image & File attributes"
                    clonedSelectedData = _a.sent();
                    objectAttribute = props.model.filter(function (eachAttribute) {
                        return eachAttribute.type === "object";
                    });
                    return [4 /*yield*/, Promise.all(objectAttribute.map(function (eachObject) { return __awaiter(_this, void 0, void 0, function () {
                            var _a;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0: return [4 /*yield*/, handleParseImageField(id, clonedSelectedData, (_a = eachObject.objectData) !== null && _a !== void 0 ? _a : [], eachObject.id)];
                                    case 1:
                                        clonedSelectedData = _b.sent();
                                        return [2 /*return*/, null];
                                }
                            });
                        }); }))];
                case 2:
                    _a.sent();
                    listObjectAttribute = props.model.filter(function (eachAttribute) {
                        return eachAttribute.type === "listObject";
                    });
                    return [4 /*yield*/, Promise.all(listObjectAttribute.map(function (eachObject) { return __awaiter(_this, void 0, void 0, function () {
                            var _a;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0: return [4 /*yield*/, handleParseImageField(id, clonedSelectedData, (_a = eachObject.objectData) !== null && _a !== void 0 ? _a : [], eachObject.id, true)];
                                    case 1:
                                        clonedSelectedData = _b.sent();
                                        return [2 /*return*/, null];
                                }
                            });
                        }); }))];
                case 3:
                    _a.sent();
                    return [2 /*return*/, clonedSelectedData];
            }
        });
    }); };
    var handleUploadEndpoint = function (eachImage) {
        if (devSettings.uploadEndpoint)
            return devSettings.uploadEndpoint;
        else if (eachImage.uploadEndpoint)
            return eachImage.uploadEndpoint;
        else
            return "/api/asset";
    };
    /**
     *
     * INFO: Image Endpoint
     * Image - imageColl/dataId/file.png
     * Object - imageColl/dataId/attributeId/file.png
     * List Object - imageColl/dataId/attributeId/itemId/file.png
     *
     * Multi Image - imageColl/dataId/token${imageFileExtension} - Applies to the same to object & listObject
     */
    var handleParseImageField = function (dataId, selectedData, model, objectId, listObject) { return __awaiter(_this, void 0, void 0, function () {
        var uploadAsset_1, removeAsset_1, imageAttribute, multiImageAttribute, err_2;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    uploadAsset_1 = function (eachImage, selectedField, listObjectId, multiple) { return __awaiter(_this, void 0, void 0, function () {
                        var uploadedData_1, imageCollectionName, imageParentId, responseData, err_3;
                        var _this = this;
                        var _a, _b, _c;
                        return __generator(this, function (_d) {
                            switch (_d.label) {
                                case 0:
                                    _d.trys.push([0, 6, , 7]);
                                    if (!(typeof selectedField === "string")) return [3 /*break*/, 1];
                                    return [2 /*return*/, selectedField];
                                case 1:
                                    if (!(multiple &&
                                        selectedField["upload"] &&
                                        Array.isArray(selectedField["upload"]))) return [3 /*break*/, 3];
                                    uploadedData_1 = [];
                                    return [4 /*yield*/, Promise.all(selectedField["upload"].map(function (eachField) { return __awaiter(_this, void 0, void 0, function () {
                                            var imageCollectionName, imageParentId, fileName, responseData;
                                            var _a, _b;
                                            return __generator(this, function (_c) {
                                                switch (_c.label) {
                                                    case 0:
                                                        imageCollectionName = (_a = eachImage.imageCollectionName) !== null && _a !== void 0 ? _a : "";
                                                        if (objectId) {
                                                            imageCollectionName += "/".concat(dataId);
                                                        }
                                                        imageParentId = objectId ? objectId : dataId;
                                                        if (listObjectId) {
                                                            imageParentId += "/".concat(listObjectId);
                                                        }
                                                        fileName = (0, uuid_1.v4)() + eachImage.imageFileName;
                                                        return [4 /*yield*/, handleUploadAxios(handleUploadEndpoint(eachImage), imageParentId, imageCollectionName, fileName, eachField.fileName, (_b = devSettings.bucketName) !== null && _b !== void 0 ? _b : "")];
                                                    case 1:
                                                        responseData = _c.sent();
                                                        if (responseData.data)
                                                            uploadedData_1.push({
                                                                token: responseData.data.data,
                                                                fileName: fileName,
                                                            });
                                                        return [2 /*return*/, null];
                                                }
                                            });
                                        }); }))];
                                case 2:
                                    _d.sent();
                                    return [2 /*return*/, selectedField["data"].concat(uploadedData_1)];
                                case 3:
                                    if (!(selectedField instanceof File)) return [3 /*break*/, 5];
                                    imageCollectionName = (_a = eachImage.imageCollectionName) !== null && _a !== void 0 ? _a : "";
                                    if (objectId) {
                                        imageCollectionName += "/".concat(dataId);
                                    }
                                    imageParentId = objectId ? objectId : dataId;
                                    if (listObjectId) {
                                        imageParentId += "/".concat(listObjectId);
                                    }
                                    return [4 /*yield*/, handleUploadAxios(handleUploadEndpoint(eachImage), imageParentId, imageCollectionName, (_b = eachImage.imageFileName) !== null && _b !== void 0 ? _b : "", selectedField, (_c = devSettings.bucketName) !== null && _c !== void 0 ? _c : "")];
                                case 4:
                                    responseData = _d.sent();
                                    if (responseData.data) {
                                        return [2 /*return*/, responseData.data.data];
                                    }
                                    _d.label = 5;
                                case 5: return [3 /*break*/, 7];
                                case 6:
                                    err_3 = _d.sent();
                                    return [3 /*break*/, 7];
                                case 7: return [2 /*return*/];
                            }
                        });
                    }); };
                    removeAsset_1 = function (eachImage, selectedField) { return __awaiter(_this, void 0, void 0, function () {
                        var _this = this;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, Promise.all(selectedField["remove"].map(function (eachField) { return __awaiter(_this, void 0, void 0, function () {
                                        var startIndex, endIndex, imageFileName;
                                        var _a, _b, _c;
                                        return __generator(this, function (_d) {
                                            switch (_d.label) {
                                                case 0:
                                                    startIndex = eachField.fileName.lastIndexOf("%2F") + 3;
                                                    endIndex = eachField.fileName.indexOf("?alt=media&token=");
                                                    imageFileName = eachField.fileName.substring(startIndex, endIndex);
                                                    return [4 /*yield*/, handleRemoveImageAxios(handleUploadEndpoint(eachImage), (_a = props.id) !== null && _a !== void 0 ? _a : "", (_b = eachImage.imageCollectionName) !== null && _b !== void 0 ? _b : "", imageFileName, (_c = devSettings.bucketName) !== null && _c !== void 0 ? _c : "")];
                                                case 1:
                                                    _d.sent();
                                                    return [2 /*return*/];
                                            }
                                        });
                                    }); }))];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); };
                    imageAttribute = model.filter(function (eachAttribute) {
                        return eachAttribute.type === "image" || eachAttribute.type === "file";
                    });
                    return [4 /*yield*/, Promise.all(imageAttribute.map(function (eachImage) { return __awaiter(_this, void 0, void 0, function () {
                            var _a, _b, _c, _d;
                            var _this = this;
                            return __generator(this, function (_e) {
                                switch (_e.label) {
                                    case 0:
                                        if (!listObject) return [3 /*break*/, 3];
                                        if (!objectId)
                                            return [2 /*return*/];
                                        if (!Array.isArray(selectedData[objectId])) return [3 /*break*/, 2];
                                        return [4 /*yield*/, Promise.all(selectedData[objectId].map(function (eachListItem, index) { return __awaiter(_this, void 0, void 0, function () {
                                                var selectedObjectId, _a, _b;
                                                var _c;
                                                return __generator(this, function (_d) {
                                                    switch (_d.label) {
                                                        case 0:
                                                            selectedObjectId = (_c = eachListItem.id) !== null && _c !== void 0 ? _c : (0, uuid_1.v4)();
                                                            _a = selectedData[objectId][index];
                                                            _b = eachImage.id;
                                                            return [4 /*yield*/, uploadAsset_1(eachImage, selectedData[objectId][index][eachImage.id], selectedObjectId)];
                                                        case 1:
                                                            _a[_b] =
                                                                _d.sent();
                                                            return [2 /*return*/, null];
                                                    }
                                                });
                                            }); }))];
                                    case 1:
                                        _e.sent();
                                        _e.label = 2;
                                    case 2: return [3 /*break*/, 7];
                                    case 3:
                                        if (!objectId) return [3 /*break*/, 5];
                                        _a = selectedData[objectId];
                                        _b = eachImage.id;
                                        return [4 /*yield*/, uploadAsset_1(eachImage, selectedData[objectId][eachImage.id])];
                                    case 4:
                                        _a[_b] = _e.sent();
                                        return [3 /*break*/, 7];
                                    case 5:
                                        _c = selectedData;
                                        _d = eachImage.id;
                                        return [4 /*yield*/, uploadAsset_1(eachImage, selectedData[eachImage.id])];
                                    case 6:
                                        _c[_d] = _e.sent();
                                        _e.label = 7;
                                    case 7: return [2 /*return*/, null];
                                }
                            });
                        }); }))];
                case 1:
                    _a.sent();
                    multiImageAttribute = model.filter(function (eachAttribute) {
                        return (eachAttribute.type === "multipleImage" ||
                            eachAttribute.type === "multipleFile");
                    });
                    return [4 /*yield*/, Promise.all(multiImageAttribute.map(function (eachImage) { return __awaiter(_this, void 0, void 0, function () {
                            var _a, _b;
                            return __generator(this, function (_c) {
                                switch (_c.label) {
                                    case 0: return [4 /*yield*/, removeAsset_1(eachImage, selectedData[eachImage.id])];
                                    case 1:
                                        _c.sent();
                                        _a = selectedData;
                                        _b = eachImage.id;
                                        return [4 /*yield*/, uploadAsset_1(eachImage, selectedData[eachImage.id], "", true)];
                                    case 2:
                                        _a[_b] = _c.sent();
                                        return [2 /*return*/, null];
                                }
                            });
                        }); }))];
                case 2:
                    _a.sent();
                    return [2 /*return*/, selectedData];
                case 3:
                    err_2 = _a.sent();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleRemoveImageAxios = function (imageEndpoint, assetParentId, assetCollectionName, assetFileName, bucketName) { return __awaiter(_this, void 0, void 0, function () {
        var dataForm, err_4;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    dataForm = new FormData();
                    dataForm.append("data[assetCollectionName]", assetCollectionName);
                    dataForm.append("data[assetParentId]", assetParentId);
                    dataForm.append("data[assetFileName]", assetFileName);
                    if (bucketName)
                        dataForm.append("data[bucketName]", bucketName);
                    return [4 /*yield*/, ((_a = props.lib) === null || _a === void 0 ? void 0 : _a.axios({
                            method: "post",
                            url: "".concat(imageEndpoint, "/delete"),
                            data: dataForm,
                            headers: { "Content-Type": "multipart/form-data" },
                        }))];
                case 1:
                    _b.sent();
                    return [3 /*break*/, 3];
                case 2:
                    err_4 = _b.sent();
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleRemoveImage = function (bucketName) { return __awaiter(_this, void 0, void 0, function () {
        var data, uploadEndpoint, err_5;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    data = new FormData();
                    data.append("data[assetCollectionName]", props.collectionId);
                    data.append("data[assetParentId]", (_a = props.id) !== null && _a !== void 0 ? _a : "");
                    uploadEndpoint = devSettings.uploadEndpoint
                        ? devSettings.uploadEndpoint
                        : "/api/asset";
                    if (bucketName)
                        data.append("data[bucketName]", bucketName);
                    return [4 /*yield*/, ((_b = props.lib) === null || _b === void 0 ? void 0 : _b.axios({
                            data: data,
                            method: "post",
                            url: "".concat(uploadEndpoint, "/deleteDirectory"),
                            headers: { "Content-Type": "multipart/form-data" },
                        }))];
                case 1:
                    _c.sent();
                    return [3 /*break*/, 3];
                case 2:
                    err_5 = _c.sent();
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    //=====================================================================================
    //SECTION: Handle CRUD
    //=====================================================================================
    var handleGenerateDeletePasscode = function () {
        var chars = "0123456789";
        var passcodeLength = 6;
        var passcode = "";
        var i = 0;
        while (i < passcodeLength) {
            var randomIndex = Math.floor(Math.random() * chars.length);
            passcode += chars.charAt(randomIndex);
            i++;
        }
        setDeletePasscode(passcode);
    };
    var handleMultipleRemoveSelectedData = function () { return __awaiter(_this, void 0, void 0, function () {
        var passcodeMatch, ids, query, data, uploadEndpoint, err_6;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 8, , 9]);
                    setLoading(true);
                    setModalVisible(true);
                    passcodeMatch = deletePasscodeInput === deletePasscode;
                    if (!passcodeMatch) return [3 /*break*/, 6];
                    ids = [];
                    if (!selectAll) return [3 /*break*/, 2];
                    query = renderSearchFilterConditions();
                    return [4 /*yield*/, writeServerQuery.call("batchDelete", { query: query })];
                case 1:
                    ids = _b.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, writeServerQuery.call("batchDelete", { id: selectedIds })];
                case 3:
                    ids = _b.sent();
                    _b.label = 4;
                case 4:
                    data = new FormData();
                    data.append("data[assetCollectionName]", props.collectionId);
                    data.append("data[assetParentId]", JSON.stringify(ids !== null && ids !== void 0 ? ids : []));
                    uploadEndpoint = devSettings.uploadEndpoint
                        ? devSettings.uploadEndpoint
                        : "/api/asset";
                    if (props.devSettings.bucketName)
                        data.append("data[bucketName]", props.devSettings.bucketName);
                    return [4 /*yield*/, ((_a = props.lib) === null || _a === void 0 ? void 0 : _a.axios({
                            data: data,
                            method: "post",
                            url: "".concat(uploadEndpoint, "/batchDeleteDirectory"),
                            headers: { "Content-Type": "multipart/form-data" },
                        }))];
                case 5:
                    _b.sent();
                    return [3 /*break*/, 7];
                case 6:
                    setNotification({
                        type: false,
                        title: "Incorrect Passcode",
                        msg: "Passcode is Incorrect.",
                    });
                    setLoading(false);
                    setModalVisible(false);
                    return [2 /*return*/];
                case 7: return [3 /*break*/, 9];
                case 8:
                    err_6 = _b.sent();
                    return [3 /*break*/, 9];
                case 9:
                    setDeletePasscodeInput("");
                    handleRefresh();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleRemoveSelectedData = function () { return __awaiter(_this, void 0, void 0, function () {
        var selectedId, res, err_7;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 4, , 5]);
                    selectedId = props.id;
                    if (!selectedId) return [3 /*break*/, 3];
                    setLoading(true);
                    setModalVisible(true);
                    setDeleteModal(true);
                    return [4 /*yield*/, handleRemoveImage((_a = devSettings.bucketName) !== null && _a !== void 0 ? _a : "")];
                case 1:
                    _b.sent();
                    return [4 /*yield*/, writeServerQuery.call("delete", { id: selectedId })];
                case 2:
                    res = _b.sent();
                    if (res)
                        handleNavigate("".concat(props.localURLEndpoint, "?type=list&collection=").concat(props.collectionId, "&data=r"));
                    _b.label = 3;
                case 3: return [3 /*break*/, 5];
                case 4:
                    err_7 = _b.sent();
                    setDeleteModal(false);
                    return [3 /*break*/, 5];
                case 5:
                    setLoading(false);
                    setModalVisible(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleBatchUpdateData = function () { return __awaiter(_this, void 0, void 0, function () {
        var model_1, columnId_1, dataToSubmit_1, isFile, res, res, err_8;
        var _a, _b;
        var _this = this;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 7, , 8]);
                    setLoading(true);
                    setModalVisible(true);
                    model_1 = props.model.find(function (eachModel) { return eachModel.id === batchUpdateData.columnId; });
                    columnId_1 = batchUpdateData.columnId;
                    dataToSubmit_1 = batchUpdateData.columnData;
                    isFile = (model_1 === null || model_1 === void 0 ? void 0 : model_1.type) === "image" || (model_1 === null || model_1 === void 0 ? void 0 : model_1.type) === "file";
                    if ((model_1 === null || model_1 === void 0 ? void 0 : model_1.optional) && dataToSubmit_1[columnId_1] === undefined) {
                        if (model_1.type === "address")
                            dataToSubmit_1 = (_a = {}, _a[columnId_1] = { name: "", lat: 0, lng: 0 }, _a);
                        else
                            dataToSubmit_1 = (_b = {}, _b[columnId_1] = "", _b);
                    }
                    if (!(isFile && dataToSubmit_1[columnId_1])) return [3 /*break*/, 2];
                    return [4 /*yield*/, Promise.all(selectedIds.map(function (eachId) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, handleSubmitData("update", eachId, columnId_1, dataToSubmit_1)];
                                    case 1: return [2 /*return*/, _a.sent()];
                                }
                            });
                        }); }))];
                case 1:
                    res = _c.sent();
                    if (res) {
                        setLoading(false);
                        setSelectedIds([]);
                        setModalVisible(false);
                        setBatchUpdateModal(false);
                    }
                    return [3 /*break*/, 6];
                case 2:
                    if (!(isFile && !dataToSubmit_1[columnId_1])) return [3 /*break*/, 4];
                    return [4 /*yield*/, Promise.all(selectedIds.map(function (eachId) { return __awaiter(_this, void 0, void 0, function () {
                            var _a, _b, _c;
                            return __generator(this, function (_d) {
                                switch (_d.label) {
                                    case 0: return [4 /*yield*/, handleRemoveImageAxios(handleUploadEndpoint(model_1), eachId, (_a = model_1.imageCollectionName) !== null && _a !== void 0 ? _a : "", (_b = model_1.imageFileName) !== null && _b !== void 0 ? _b : "", (_c = devSettings.bucketName) !== null && _c !== void 0 ? _c : "")];
                                    case 1:
                                        _d.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); }))];
                case 3:
                    _c.sent();
                    _c.label = 4;
                case 4: return [4 /*yield*/, writeServerQuery.call("batchUpdate", {
                        data: dataToSubmit_1,
                        query: [
                            {
                                queryId: "_id",
                                type: "in",
                                value: selectedIds,
                            },
                        ],
                    })];
                case 5:
                    res = _c.sent();
                    if (res)
                        handleRefresh(false);
                    _c.label = 6;
                case 6: return [3 /*break*/, 8];
                case 7:
                    err_8 = _c.sent();
                    if (err_8.response && err_8.response.status === 400) {
                        setNotification({
                            type: false,
                            title: "Error",
                            msg: err_8.response.data.err,
                        });
                    }
                    return [3 /*break*/, 8];
                case 8:
                    setBatchUpdateData({ columnId: "", columnData: {} });
                    return [2 /*return*/];
            }
        });
    }); };
    var handleSubmitData = function (type, rowId, columnId, data) { return __awaiter(_this, void 0, void 0, function () {
        var selectedId, id, createSelectedData_1, uniqueDataStructure, uniqueColumnId, res, dataToSubmit, selectedIndex_2, err_9;
        var _a;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 11, , 12]);
                    selectedId = "";
                    if (type === "update")
                        selectedId = rowId !== null && rowId !== void 0 ? rowId : "";
                    else if (type === "create")
                        selectedId = "new";
                    else if (props.id)
                        selectedId = props.id;
                    else
                        selectedId = "new";
                    id = "";
                    if (type === "update")
                        id = rowId !== null && rowId !== void 0 ? rowId : "";
                    else if (selectedId === "new")
                        id = (0, uuid_1.v4)();
                    else
                        id = (_b = props.id) !== null && _b !== void 0 ? _b : "";
                    return [4 /*yield*/, handleUploadImage(id, data)];
                case 1:
                    createSelectedData_1 = _c.sent();
                    uniqueDataStructure = props.model.filter(function (eachStructure) {
                        return eachStructure.unique;
                    });
                    uniqueColumnId = uniqueDataStructure.length > 0 ? uniqueDataStructure[0].id : undefined;
                    res = "";
                    if (!(selectedId === "new")) return [3 /*break*/, 3];
                    createSelectedData_1[serverId] = id;
                    return [4 /*yield*/, writeServerQuery.call("create", {
                            data: createSelectedData_1,
                            unique: uniqueColumnId,
                        })];
                case 2:
                    res = _c.sent();
                    return [3 /*break*/, 5];
                case 3:
                    if (!selectedId) return [3 /*break*/, 5];
                    dataToSubmit = void 0;
                    if (type === "update" && columnId) {
                        dataToSubmit = (_a = {},
                            _a[columnId] = createSelectedData_1[columnId],
                            _a);
                    }
                    else
                        dataToSubmit = __assign(__assign({}, createSelectedData_1), { baseDraft: false });
                    return [4 /*yield*/, writeServerQuery.call("update", {
                            id: selectedId,
                            data: dataToSubmit,
                            unique: uniqueColumnId,
                        })];
                case 4:
                    res = _c.sent();
                    _c.label = 5;
                case 5:
                    if (!(type === "update" || type === "create")) return [3 /*break*/, 10];
                    if (!res) return [3 /*break*/, 10];
                    if (!(type === "update")) return [3 /*break*/, 8];
                    if (!columnId) return [3 /*break*/, 7];
                    selectedIndex_2 = -1;
                    tableData.map(function (eachData, index) {
                        if (eachData.id === rowId || eachData._id === rowId) {
                            eachData[columnId] = createSelectedData_1[columnId];
                            selectedIndex_2 = index;
                        }
                        return null;
                    });
                    return [4 /*yield*/, handleGetListData({ data: [tableData[selectedIndex_2]] }, "update", rowId)];
                case 6:
                    _c.sent();
                    _c.label = 7;
                case 7: return [3 /*break*/, 10];
                case 8: return [4 /*yield*/, handleGetListData({ data: [createSelectedData_1] }, "create")];
                case 9:
                    _c.sent();
                    _c.label = 10;
                case 10: return [2 /*return*/, res];
                case 11:
                    err_9 = _c.sent();
                    if (err_9.response && err_9.response.status === 400) {
                        setNotification({
                            type: false,
                            title: "Error",
                            msg: err_9.response.data.err,
                        });
                    }
                    return [3 /*break*/, 12];
                case 12: return [2 /*return*/];
            }
        });
    }); };
    var handleSubmit = function () { return __awaiter(_this, void 0, void 0, function () {
        var res, err_10;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    setLoading(true);
                    setModalVisible(true);
                    return [4 /*yield*/, handleSubmitData()];
                case 1:
                    res = _b.sent();
                    setModalVisible(false);
                    setLoading(false);
                    if (res) {
                        if (props.onComplete) {
                            props.onComplete();
                        }
                        else {
                            if (((_a = props.organise) === null || _a === void 0 ? void 0 : _a.debugOnChangeType) && props.id !== "new") {
                                props.organise.debugOnChangeType("list", "");
                            }
                            else
                                handleNavigate("".concat(props.localURLEndpoint, "?type=list&collection=").concat(props.collectionId) +
                                    (props.id === "new" ? "&data=r" : ""));
                        }
                    }
                    return [3 /*break*/, 3];
                case 2:
                    err_10 = _b.sent();
                    setModalVisible(false);
                    setLoading(false);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleRetrieveSelectedData = function (responseData) { return __awaiter(_this, void 0, void 0, function () {
        var dummyRespData, dummyReferenceModelSchema, newRespData, _a;
        var _b, _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    if (!responseData.data) return [3 /*break*/, 4];
                    dummyRespData = JSON.parse(JSON.stringify(responseData.data), utils_1.jsonReviver);
                    dummyReferenceModelSchema = JSON.parse(JSON.stringify(referenceModelSchema));
                    if (!(props.type === "read")) return [3 /*break*/, 2];
                    return [4 /*yield*/, (0, display_1.handleRetrieveDeepModel)(dummyRespData, (_b = props.model) !== null && _b !== void 0 ? _b : [], dbModule, devSettings.server, devSettings.dbEndpoint, devSettings.schemaEndpoint, devSettings.imageEndpoint, (_c = props.id) !== null && _c !== void 0 ? _c : "", dummyReferenceModelSchema, (_d = devSettings.organisationMembers) !== null && _d !== void 0 ? _d : [], setReferenceSchema, undefined, (_e = devSettings.bucketName) !== null && _e !== void 0 ? _e : "")];
                case 1:
                    _a = _f.sent();
                    return [3 /*break*/, 3];
                case 2:
                    _a = dummyRespData;
                    _f.label = 3;
                case 3:
                    newRespData = _a;
                    setSelectedData(newRespData);
                    (0, display_1.handleRetrieveReferenceOptions)(newRespData, props.model, dbModule, devSettings.server, devSettings.dbEndpoint, devSettings.dbAPIToken, setReferencesOptions);
                    _f.label = 4;
                case 4:
                    setModalVisible(false);
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleOnChangeData = function () {
        var _a;
        if (modalVisible && selectedObjectStructureId) {
            var filterObjectModel = props.model.find(function (eachModel) {
                return eachModel.id === selectedObjectStructureId;
            });
            return {
                data: selectedObjectData,
                model: (_a = filterObjectModel === null || filterObjectModel === void 0 ? void 0 : filterObjectModel.objectData) !== null && _a !== void 0 ? _a : [],
            };
        }
        else if (batchUpdateModal && batchUpdateData.columnId) {
            return {
                data: batchUpdateData.columnData,
                model: props.model,
            };
        }
        else {
            return {
                data: selectedData,
                model: props.model,
            };
        }
    };
    var handleUpdateChangeData = function (data) {
        var _a;
        if (modalVisible && selectedObjectStructureId) {
            setSelectedObjectData(data);
        }
        else if (batchUpdateModal && batchUpdateData.columnId) {
            var selectedModel = props.model.find(function (eachModel) { return eachModel.id === batchUpdateData.columnId; });
            if (selectedModel) {
                var clonedData = JSON.parse(JSON.stringify(data));
                (0, display_1.handleCastDataAttribute)(selectedModel, data, clonedData, true);
                setBatchUpdateData({
                    columnId: batchUpdateData.columnId,
                    columnData: (_a = {},
                        _a[batchUpdateData.columnId] = clonedData[selectedModel.id],
                        _a),
                });
            }
        }
        else {
            setSelectedData(data);
        }
    };
    var handleOnChangeFile = function (e) {
        var _a = handleOnChangeData(), data = _a.data, model = _a.model;
        var clonedData = (0, display_1.handleClonedDataAttribute)(data, model);
        clonedData[e.target.id] =
            e.target.files.length > 0 ? e.target.files[0] : undefined;
        handleUpdateChangeData(clonedData);
    };
    var handleOnChangeFiles = function (id, value, action) {
        var _a = handleOnChangeData(), data = _a.data, model = _a.model;
        var clonedData = (0, display_1.handleClonedDataAttribute)(data, model);
        var previousData = clonedData[id] && clonedData[id]["data"] ? clonedData[id]["data"] : [];
        var previousUploadData = clonedData[id] && clonedData[id]["upload"]
            ? clonedData[id]["upload"]
            : [];
        var previousRemoveData = clonedData[id] && clonedData[id]["remove"]
            ? clonedData[id]["remove"]
            : [];
        if (action === "upload") {
            clonedData[id] = __assign(__assign({}, clonedData[id]), { upload: __spreadArray(__spreadArray([], value, true), previousUploadData, true) });
        }
        else {
            if (previousData.some(function (file) {
                return file.token === value.token;
            })) {
                clonedData[id] = __assign(__assign({}, clonedData[id]), { data: previousData.filter(function (file) {
                        return file.token !== value.token;
                    }), remove: __spreadArray(__spreadArray([], previousRemoveData, true), [value], false) });
            }
            else {
                clonedData[id] = __assign(__assign({}, clonedData[id]), { upload: previousUploadData.filter(function (file) {
                        return file.token !== value.token;
                    }) });
            }
        }
        handleUpdateChangeData(clonedData);
    };
    var handleDeleteTab = function (tabId) {
        var _a, _b;
        if ((_a = props.organise) === null || _a === void 0 ? void 0 : _a.extendedTabs) {
            var deleteTabIndex_1 = -1;
            props.organise.extendedTabs.forEach(function (eachTab, index) {
                var id = (0, utils_1.lowercaseTextToId)(eachTab.name);
                if (id === tabId) {
                    deleteTabIndex_1 = index;
                }
            });
            if (deleteTabIndex_1 !== -1) {
                var clonedTabs = JSON.parse(JSON.stringify(props.organise.extendedTabs));
                clonedTabs.splice(deleteTabIndex_1, 1);
                if ((_b = props.organise) === null || _b === void 0 ? void 0 : _b.onChangeTabs) {
                    props.organise.onChangeTabs(clonedTabs);
                }
            }
        }
    };
    var handleOnChangeAddress = function (id, address) {
        var _a = handleOnChangeData(), data = _a.data, model = _a.model;
        var clonedData = (0, display_1.handleClonedDataAttribute)(data, model);
        clonedData[id] = address;
        handleUpdateChangeData(clonedData);
    };
    var handleOnChangeText = function (e) {
        var _a = handleOnChangeData(), data = _a.data, model = _a.model;
        var clonedData = (0, display_1.handleClonedDataAttribute)(data, model);
        clonedData[e.target.id] = e.target.value;
        handleUpdateChangeData(clonedData);
    };
    var handleOnChangeSelect = function (id, value) {
        var _a = handleOnChangeData(), data = _a.data, model = _a.model;
        var clonedData = (0, display_1.handleClonedDataAttribute)(data, model);
        clonedData[id] = value;
        handleUpdateChangeData(clonedData);
    };
    var handleOnChangeDate = function (id, value) {
        var _a = handleOnChangeData(), data = _a.data, model = _a.model;
        var clonedData = (0, display_1.handleClonedDataAttribute)(data, model);
        clonedData[id] = value;
        handleUpdateChangeData(clonedData);
    };
    var handleOnChangeMarkdown = function (id, value) {
        var _a = handleOnChangeData(), data = _a.data, model = _a.model;
        var clonedData = (0, display_1.handleClonedDataAttribute)(data, model);
        clonedData[id] = value;
        handleUpdateChangeData(clonedData);
    };
    //=====================================================================================
    //SECTION: Handle CSV
    //=====================================================================================
    var handleOnChangeCSV = function (e) {
        var _a;
        var file = e.target.files[0];
        if (file) {
            setCSVFile(file);
            (_a = props.lib) === null || _a === void 0 ? void 0 : _a.papaParser.parse(file, {
                header: true,
                dynamicTyping: true,
                complete: function (results) {
                    var fileSize = file.size / 1024 / 1024;
                    if (results.data && fileSize < 25) {
                        setCSVFileData(results.data);
                        var prefilledCSVMapAttribute_1 = {};
                        Object.entries(results.data[0]).map(function (eachRow, index) {
                            var eachKey = eachRow[0];
                            if (!eachKey)
                                return null;
                            props.model.map(function (eachModel) {
                                if (eachKey.toLowerCase().includes(eachModel.id.toLowerCase()) &&
                                    eachModel.id !== "_id" &&
                                    eachModel.id !== "id" &&
                                    eachModel.type !== "object" &&
                                    eachModel.type !== "listObject") {
                                    prefilledCSVMapAttribute_1[index] = eachModel.id;
                                }
                                return null;
                            });
                            return null;
                        });
                        setListCSVMapAttribute(prefilledCSVMapAttribute_1);
                        setStepCSVIndex(1);
                    }
                    else
                        setNotification({
                            type: false,
                            title: "Import Error",
                            msg: "Data file size is more than 25 MB",
                        });
                },
            });
        }
        else {
            setNotification({
                type: false,
                title: "Import Error",
                msg: "No file is selected",
            });
        }
    };
    var handleStepCSV = function () { return __awaiter(_this, void 0, void 0, function () {
        var csvList_1, _loop_1, _i, _a, _b, eachKey, eachValue, valid_1, errorValue_1, excelFormData, response, open_1, err_11;
        var _c, _d, _e, _f, _g;
        return __generator(this, function (_h) {
            switch (_h.label) {
                case 0:
                    _h.trys.push([0, 6, , 7]);
                    if (!(stepCSVIndex === 0)) return [3 /*break*/, 1];
                    if (csvFileData.length > 0 && csvFile)
                        setStepCSVIndex(stepCSVIndex + 1);
                    else
                        throw new Error("Please upload a .CSV file");
                    return [3 /*break*/, 5];
                case 1:
                    if (!(stepCSVIndex === 1)) return [3 /*break*/, 3];
                    csvList_1 = [];
                    _loop_1 = function (eachKey, eachValue) {
                        if (eachKey && eachValue && typeof eachValue === "string") {
                            var selectedModel = props.model.find(function (eachModel) {
                                return eachModel.id === eachValue;
                            });
                            if ((selectedModel === null || selectedModel === void 0 ? void 0 : selectedModel.type) === "object" ||
                                (selectedModel === null || selectedModel === void 0 ? void 0 : selectedModel.type) === "listObject") {
                                var selectedObjectModel = (_c = selectedModel === null || selectedModel === void 0 ? void 0 : selectedModel.objectData) === null || _c === void 0 ? void 0 : _c.find(function (eachModel) {
                                    return eachModel.id === eachValue;
                                });
                                csvList_1.push({
                                    id: (_d = listCSVObjAttribute[eachKey]) !== null && _d !== void 0 ? _d : "",
                                    ori: Number(eachKey),
                                    type: selectedModel === null || selectedModel === void 0 ? void 0 : selectedModel.type,
                                    objectId: eachValue,
                                    objectValueType: (_e = selectedObjectModel === null || selectedObjectModel === void 0 ? void 0 : selectedObjectModel.type) !== null && _e !== void 0 ? _e : "string",
                                });
                            }
                            else if ((selectedModel === null || selectedModel === void 0 ? void 0 : selectedModel.type) === "image" ||
                                (selectedModel === null || selectedModel === void 0 ? void 0 : selectedModel.type) === "file" ||
                                (selectedModel === null || selectedModel === void 0 ? void 0 : selectedModel.type) === "multipleFile" ||
                                (selectedModel === null || selectedModel === void 0 ? void 0 : selectedModel.type) === "multipleImage") {
                                csvList_1.push({
                                    id: eachValue !== null && eachValue !== void 0 ? eachValue : "",
                                    ori: Number(eachKey),
                                    type: selectedModel === null || selectedModel === void 0 ? void 0 : selectedModel.type,
                                    imageCollectionName: selectedModel.imageCollectionName,
                                    imageFileName: selectedModel.imageFileName,
                                    uploadEndpoint: selectedModel.uploadEndpoint,
                                });
                            }
                            else {
                                csvList_1.push({
                                    id: eachValue !== null && eachValue !== void 0 ? eachValue : "",
                                    ori: Number(eachKey),
                                    type: (_f = selectedModel === null || selectedModel === void 0 ? void 0 : selectedModel.type) !== null && _f !== void 0 ? _f : "string",
                                });
                            }
                        }
                    };
                    for (_i = 0, _a = Object.entries(listCSVMapAttribute); _i < _a.length; _i++) {
                        _b = _a[_i], eachKey = _b[0], eachValue = _b[1];
                        _loop_1(eachKey, eachValue);
                    }
                    valid_1 = true;
                    errorValue_1 = "";
                    return [4 /*yield*/, Promise.all(props.model.map(function (eachEachModel) {
                            if (eachEachModel.id === "_id" || eachEachModel.id === "id") {
                                return "";
                            }
                            if (!eachEachModel.optional) {
                                // INFO : Validate and compare the modal with csv list and return true if > 1 consist within
                                var innearValidation = csvList_1.some(function (eachCsvList) {
                                    if (eachCsvList.type === "object" ||
                                        eachCsvList.type === "listObject") {
                                        return eachEachModel.id === eachCsvList.objectId;
                                    }
                                    else {
                                        return eachEachModel.id === eachCsvList.id;
                                    }
                                });
                                if (!innearValidation) {
                                    errorValue_1 = errorValue_1 + "<" + eachEachModel.id + ">";
                                    valid_1 = false;
                                }
                            }
                            return null;
                        }))];
                case 2:
                    _h.sent();
                    if (!valid_1) {
                        throw new Error("Please select how you want to map your data to ".concat(errorValue_1));
                    }
                    else {
                        setCSVAPIAttribute(csvList_1);
                        setStepCSVIndex(stepCSVIndex + 1);
                    }
                    return [3 /*break*/, 5];
                case 3:
                    if (!(stepCSVIndex === 2)) return [3 /*break*/, 5];
                    // INFO - Call Space Excel API
                    setLoading(true);
                    excelFormData = new FormData();
                    excelFormData.append("data[parsedDataStructure]", JSON.stringify(csvAPIAttribute));
                    excelFormData.append("data[spaceId]", props.collectionId);
                    excelFormData.append("file", csvFile);
                    return [4 /*yield*/, ((_g = props.lib) === null || _g === void 0 ? void 0 : _g.axios({
                            url: "/api/csv/import",
                            method: "post",
                            data: excelFormData,
                            headers: { "Content-Type": "multipart/form-data" },
                        }))];
                case 4:
                    response = _h.sent();
                    setLoading(false);
                    if (response.data) {
                        setNotification({
                            type: true,
                            title: "Data has been imported successfully",
                            msg: response.data.msg,
                        });
                        open_1 = false;
                        if (response.data.content.length > 0) {
                            setImportTableData(response.data.content);
                            setStepCSVIndex(3);
                            open_1 = true;
                        }
                        handleRefresh(open_1);
                    }
                    _h.label = 5;
                case 5: return [3 /*break*/, 7];
                case 6:
                    err_11 = _h.sent();
                    setLoading(false);
                    setNotification({
                        type: false,
                        title: "Import Error",
                        msg: err_11.message,
                    });
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var handleExportCSVData = function () { return __awaiter(_this, void 0, void 0, function () {
        var res, err_12;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    setLoading(true);
                    return [4 /*yield*/, ((_a = props.lib) === null || _a === void 0 ? void 0 : _a.axios({
                            url: "/api/csv/export",
                            method: "post",
                            data: { data: { spaceId: props.collectionId, query: queryList } },
                            headers: { "Content-Type": "multipart/form-data" },
                        }))];
                case 1:
                    res = _c.sent();
                    setExportLink((_b = res === null || res === void 0 ? void 0 : res.data.link) !== null && _b !== void 0 ? _b : "");
                    setNotification({
                        type: true,
                        title: "Export Successfully",
                        msg: "A download link had been generated.",
                    });
                    setLoading(false);
                    return [3 /*break*/, 3];
                case 2:
                    err_12 = _c.sent();
                    setLoading(false);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleViewQuery = function (index) {
        setQueryIndex(index);
        setQueryForm(!queryForm);
    };
    var handleSortQuery = function (index, sortType) {
        var _a;
        var sortList = JSON.parse(JSON.stringify(queryList));
        var ascIndex = sortType === "up" ? index - 1 : index + 1;
        _a = [
            sortList[ascIndex],
            sortList[index],
        ], sortList[index] = _a[0], sortList[ascIndex] = _a[1];
        setQueryList(sortList);
    };
    var handlePushQueryList = function (queryInput, queryIndex) {
        var tempQueryList = [];
        tempQueryList = queryList;
        if (!tempQueryList.some(function (eachQuery) { return eachQuery.queryId === queryInput.queryId; })) {
            var tempValue = queryInput.value;
            if (tempValue === "false" || tempValue === "true") {
                tempValue = tempValue === "false" ? false : true;
            }
            else if (!isNaN(tempValue)) {
                tempValue = Number(tempValue);
            }
            queryInput.value = tempValue;
            tempQueryList.push(queryInput);
            setQueryList(tempQueryList);
            setQueryForm(false);
        }
        else if (queryIndex >= 0) {
            var newQueryList = tempQueryList.map(function (eachQuery) {
                return eachQuery.queryId === queryInput.queryId ? queryInput : eachQuery;
            });
            setQueryList(newQueryList);
            handleViewQuery(-1);
        }
        else {
            setNotification({
                type: false,
                title: "Failed to add",
                msg: "Query with column ID already exists",
            });
        }
    };
    //=====================================================================================
    //SECTION: Handle Utils
    //=====================================================================================
    var handlePopUpModal = function (modalVisible, type) {
        switch (type) {
            case "sort":
                setSortModal(modalVisible);
                break;
            case "filter":
                setFilterModal(modalVisible);
                break;
            case "blixify_new_tab":
                setAddTabModal(modalVisible);
                break;
        }
        setModalVisible(modalVisible);
        if (!modalVisible) {
            setExcelModal(false);
            setQueryList([]);
            setExportExcel(false);
            setExportLink("");
            setSelectedObjectId("");
            setSelectedObjectStructureId("");
            setSelectedObjectData({});
            setStepCSVIndex(0);
            setCSVFile(null);
            setSortModal(false);
            setFilterModal(false);
            setAddTabModal(false);
            setCSVFileData([]);
            setListCSVMapAttribute({});
            setListCSVObjAttribute({});
            setCSVAPIAttribute([]);
            setImportTableData([]);
        }
    };
    var handleNavigate = function (link) {
        var _a, _b, _c;
        var href = link !== null && link !== void 0 ? link : "".concat(props.localURLEndpoint, "?type=list&collection=").concat(props.collectionId);
        if ((_a = props.lib) === null || _a === void 0 ? void 0 : _a.navigateNext) {
            props.lib.navigateNext.push(href);
        }
        else if ((_b = props.lib) === null || _b === void 0 ? void 0 : _b.navigate) {
            (_c = props.lib) === null || _c === void 0 ? void 0 : _c.navigate(href);
        }
        else if (window) {
            window.location.replace(href);
        }
    };
    var handleBreadcrumbNavigate = function () {
        var _a;
        if ((_a = props.organise) === null || _a === void 0 ? void 0 : _a.debugOnChangeType)
            props.organise.debugOnChangeType("list", "");
        else
            handleNavigate();
    };
    //=====================================================================================
    //SECTION: Render CSV
    //=====================================================================================
    var renderExcelReviewData = function () {
        var header = Object.keys(csvFileData[0]);
        var dataList = [];
        csvAPIAttribute.map(function (eachAttribute) {
            dataList.push({
                header: header[eachAttribute.ori],
                detail: eachAttribute.id,
            });
            return null;
        });
        return dataList;
    };
    var renderStepCSV = function () {
        var _a;
        switch (stepCSVIndex) {
            case 0:
                return (react_1.default.createElement(uploadInput_1.UploadInput, { lib: { axios: (_a = props.lib) === null || _a === void 0 ? void 0 : _a.axios }, label: "Please insert a csv file", fileDescription: "CSV file thats doesn't exceeds 30MB and row not more than 100 data", accept: ".csv", hidePreview: true, onChange: handleOnChangeCSV }));
            case 1:
                var filterOptions_1 = [];
                props.model.map(function (eachData) {
                    var eachDataJSON = JSON.parse(JSON.stringify(eachData));
                    if (eachData.id !== "_id" && eachData.id !== "id") {
                        filterOptions_1.push({
                            key: eachDataJSON.id,
                            label: eachDataJSON.name,
                        });
                    }
                    return "";
                });
                return (react_1.default.createElement(react_1.default.Fragment, null, csvFileData.length > 0 && (react_1.default.createElement("div", { className: "pb-32" }, Object.entries(csvFileData[0]).map(function (eachRow, index) {
                    var eachKey = eachRow[0];
                    if (!eachKey)
                        return null;
                    var clonedListValue = JSON.parse(JSON.stringify(listCSVMapAttribute));
                    var selectedObjectModel = props.model.find(function (eachModel) {
                        return ((eachModel.id === clonedListValue[index] &&
                            eachModel.type === "listObject") ||
                            eachModel.type === "object");
                    });
                    return (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("div", { className: "grid items-center grid-cols-3 mt-6" },
                            eachKey,
                            react_1.default.createElement(select_1.Select, { containerClassName: selectedObjectModel ? "ml-2" : "ml-2 col-span-2", label: "", options: filterOptions_1, value: clonedListValue[index], onChange: function (value) {
                                    var clonedListValueAttribute = JSON.parse(JSON.stringify(listCSVMapAttribute));
                                    clonedListValueAttribute[index] = value;
                                    setListCSVMapAttribute(clonedListValueAttribute);
                                } }),
                            selectedObjectModel && (react_1.default.createElement(select_1.Select, { containerClassName: "ml-4", label: "", options: (0, display_1.renderObjectOptions)(selectedObjectModel.objectData), value: listCSVObjAttribute[index], onChange: function (value) {
                                    var clonedListObjectValueAttribute = JSON.parse(JSON.stringify(listCSVObjAttribute));
                                    clonedListObjectValueAttribute[index] = value;
                                    setListCSVObjAttribute(clonedListObjectValueAttribute);
                                } })))));
                })))));
            case 2:
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("div", { className: "flex flex-col mx-auto mt-2" }, "Mapped Column"),
                    react_1.default.createElement(table_1.Table, { loading: false, data: renderExcelReviewData(), hidePagination: true, limit: csvAPIAttribute.length + 1, header: [
                            { key: "header", title: "Excel Column" },
                            { key: "detail", title: "Mapping Column" },
                        ] })));
            case 3:
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("div", { className: "flex flex-col mx-auto mt-2" }, "Invalid Excel Column Field required"),
                    react_1.default.createElement(table_1.Table, { loading: false, data: importTableData, hidePagination: true, limit: csvAPIAttribute.length + 1, header: [
                            { key: "err", title: "Invalid field" },
                            { key: "msg", title: "Message" },
                        ] })));
            default:
                return null;
        }
    };
    var renderQueryData = function () {
        var queryStructureView = [];
        var sortComponent = undefined;
        queryList.map(function (data, index) {
            if (queryList.length > 1) {
                var upData_1 = index === queryList.length - 1;
                sortComponent = (react_1.default.createElement("div", { className: "ml-2 cursor-pointer", onClick: function () {
                        handleSortQuery(index, upData_1 ? "up" : "down");
                    } }, upData_1 ? (react_1.default.createElement(outline_1.ArrowUpIcon, { className: "block w-5 h-5 text-primary-600" })) : (react_1.default.createElement(outline_1.ArrowDownIcon, { className: "block w-5 h-5 text-primary-600" }))));
            }
            var value = data.value;
            var isDate = (0, moment_1.default)(value);
            if (isDate.isValid())
                value = (0, moment_1.default)(value).format("DD/MM/YYYY h:mm a");
            queryStructureView.push({
                key: index,
                name: data.queryId,
                value: value,
                sort: sortComponent,
                view: (react_1.default.createElement("div", { className: "ml-2 cursor-pointer", onClick: function () {
                        handleViewQuery(index);
                    } },
                    react_1.default.createElement(outline_1.EyeIcon, { className: "block w-5 h-5 text-primary-600" }))),
                del: (react_1.default.createElement("div", { className: "ml-2 cursor-pointer", onClick: function () {
                        var temp = JSON.parse(JSON.stringify(queryList));
                        temp.splice(index, 1);
                        setQueryList(temp);
                    } },
                    react_1.default.createElement(outline_1.TrashIcon, { className: "block w-5 h-5 text-primary-600" }))),
            });
            return "";
        });
        return queryStructureView;
    };
    //=====================================================================================
    //SECTION: Render CRUD
    //=====================================================================================
    var renderTableHeader = function () {
        var tableHeader = [];
        props.model.map(function (eachAttribute) {
            if (eachAttribute.id === "baseUpdatedAt" ||
                eachAttribute.id === "baseDraft" ||
                eachAttribute.type === "listObject" ||
                eachAttribute.type === "file" ||
                eachAttribute.type === "multipleFile" ||
                eachAttribute.type === "multipleImage" ||
                eachAttribute.type === "markdown" ||
                eachAttribute.hide) {
                return null;
            }
            tableHeader.push(__assign(__assign({}, eachAttribute), { key: eachAttribute.id, title: eachAttribute.name }));
            return null;
        });
        if (isEditor)
            tableHeader.push({
                key: "update",
                title: "Update",
            });
        return tableHeader;
    };
    var renderCursor = function () {
        if (devSettings.server === "mongoServer") {
            return pageIndex === 0 ? undefined : pageIndex * limit;
        }
        else {
            return lastCursor ? undefined : lastCursor;
        }
    };
    var renderObjectTags = function (id) {
        var elementList = [];
        for (var _i = 0, _a = Object.entries(selectedData[id]); _i < _a.length; _i++) {
            var _b = _a[_i], eachKey = _b[0], eachValue = _b[1];
            if (eachValue && eachValue.toString().length > 0)
                elementList.push(react_1.default.createElement("div", { key: eachKey, className: "bg-primary-600 text-white rounded m-0.5" },
                    react_1.default.createElement("p", { className: "px-2 py-1 text-xs text-wrap" }, eachKey)));
        }
        return elementList;
    };
    var renderDetailListData = function () {
        var _a;
        var detailList = [];
        var _loop_2 = function (eachKey, eachValue) {
            if (eachKey !== "id" &&
                eachKey !== "_id" &&
                eachKey !== "baseUpdatedAt" &&
                eachKey !== "baseDraft") {
                var filterModel = props.model.find(function (eachAttribute) {
                    return eachAttribute.id === eachKey;
                });
                detailList.push({
                    title: (_a = filterModel === null || filterModel === void 0 ? void 0 : filterModel.name) !== null && _a !== void 0 ? _a : "",
                    text: eachValue,
                });
            }
        };
        for (var _i = 0, _b = Object.entries(selectedData); _i < _b.length; _i++) {
            var _c = _b[_i], eachKey = _c[0], eachValue = _c[1];
            _loop_2(eachKey, eachValue);
        }
        return detailList;
    };
    var renderListObject = function (type) {
        var isListObject = props.model.filter(function (eachAttribute) { return eachAttribute.type === "listObject"; });
        var list = {};
        var clonedSelectedData = (0, display_1.handleClonedDataAttribute)(selectedData, props.model);
        return isListObject.map(function (eachListObject) {
            var _a;
            if (clonedSelectedData[eachListObject.id] &&
                Array.isArray(clonedSelectedData[eachListObject.id])) {
                clonedSelectedData[eachListObject.id].map(function (eachObject) {
                    var _a;
                    var eachNewList = {
                        id: "",
                        title: "",
                    };
                    var isTitle = true;
                    var _loop_3 = function (eachKey, eachValue) {
                        if (eachListObject.objectData) {
                            var model = eachListObject.objectData.find(function (eachAttribute) {
                                return eachAttribute.id === eachKey;
                            });
                            switch (model === null || model === void 0 ? void 0 : model.type) {
                                case "string":
                                case "contact":
                                case "email":
                                    isTitle
                                        ? (eachNewList["title"] =
                                            typeof eachValue === "string" ? eachValue : "")
                                        : (eachNewList[eachKey] = model.name + " : " + eachValue);
                                    isTitle = false;
                                    break;
                                case "image":
                                    var url = void 0;
                                    if (typeof eachValue === "string") {
                                        url = (0, display_1.renderImageUrlFromPath)(devSettings.imageEndpoint, model.imageCollectionName + "%2F" + props.id, eachListObject.id + "%2F" + eachObject.id, model.imageFileName, eachValue, devSettings.bucketName);
                                    }
                                    else if (eachValue instanceof File) {
                                        url = URL.createObjectURL(eachValue);
                                    }
                                    eachNewList[eachKey] = (react_1.default.createElement("img", { src: url, alt: "", className: "object-contain w-10 h-10" }));
                                    break;
                                case "reference":
                                    if (referencesOptions[eachListObject.id + "." + model.id]) {
                                        var selectedReferences = referencesOptions[eachListObject.id + "." + model.id].find(function (eachOption) { return eachOption.key === eachValue; });
                                        eachNewList[eachKey] =
                                            (model === null || model === void 0 ? void 0 : model.name) +
                                                " : " +
                                                (eachValue ? (_a = selectedReferences === null || selectedReferences === void 0 ? void 0 : selectedReferences.label) !== null && _a !== void 0 ? _a : " - " : " ");
                                    }
                                    break;
                                case "date":
                                    eachNewList[eachKey] =
                                        (model === null || model === void 0 ? void 0 : model.name) +
                                            " : " +
                                            (0, display_1.renderEachRowDataBasedOnDataType)(eachValue);
                                    break;
                                case "address":
                                case "object":
                                    break;
                                default:
                                    if (eachKey === "id" && typeof eachValue === "string") {
                                        eachNewList[eachKey] = eachValue;
                                    }
                                    else {
                                        eachNewList[eachKey] = (model === null || model === void 0 ? void 0 : model.name) + " : " + eachValue;
                                    }
                                    break;
                            }
                        }
                    };
                    for (var _i = 0, _b = Object.entries(eachObject); _i < _b.length; _i++) {
                        var _c = _b[_i], eachKey = _c[0], eachValue = _c[1];
                        _loop_3(eachKey, eachValue);
                    }
                    if (list[eachListObject.id]) {
                        list[eachListObject.id].push(eachNewList);
                    }
                    else {
                        list[eachListObject.id] = [eachNewList];
                    }
                    return null;
                });
                return (react_1.default.createElement(react_1.default.Fragment, null, !list[eachListObject.id] && type === "update" ? (react_1.default.createElement("button", { type: "button", className: "relative block w-full p-12 mt-5 text-center border-2 border-gray-300 border-dashed rounded-lg", onClick: function () {
                        setSelectedObjectStructureId(eachListObject.id);
                        handlePopUpModal(true);
                    } },
                    react_1.default.createElement("svg", { className: "w-12 h-12 mx-auto text-gray-400", stroke: "currentColor", fill: "none", viewBox: "0 0 48 48", "aria-hidden": "true" },
                        react_1.default.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M8 14v20c0 4.418 7.163 8 16 8 1.381 0 2.721-.087 4-.252M8 14c0 4.418 7.163 8 16 8s16-3.582 16-8M8 14c0-4.418 7.163-8 16-8s16 3.582 16 8m0 0v14m0-4c0 4.418-7.163 8-16 8S8 28.418 8 24m32 10v6m0 0v6m0-6h6m-6 0h-6" })),
                    react_1.default.createElement("span", { className: "block mt-2 text-sm font-medium text-gray-900" },
                        "Create a new ", "".concat(eachListObject.name.toLocaleLowerCase())))) : (react_1.default.createElement(react_1.default.Fragment, null, list[eachListObject.id] && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("div", { className: "flex justify-between mt-5" },
                        react_1.default.createElement("h3", { className: "font-medium leading-6 text-gray-900 text-md sm:text-lg" }, eachListObject.name),
                        type === "update" && (react_1.default.createElement(iconButton_1.IconButton, { className: "sm", icon: react_1.default.createElement(outline_1.PlusCircleIcon, { className: "w-6 h-6 text-white" }), background: "bg-primary-500 hover:bg-primary-600", onClick: function () {
                                setSelectedObjectStructureId(eachListObject.id);
                                handlePopUpModal(true);
                            } }))),
                    react_1.default.createElement(list_1.List, { className: "mt-5", list: (_a = list[eachListObject.id]) !== null && _a !== void 0 ? _a : [], loading: false, onClickRow: function (id) {
                            handleSelectListObjectData(id, eachListObject.id);
                        } })))))));
            }
            else {
                return react_1.default.createElement(react_1.default.Fragment, null);
            }
        });
    };
    var renderContent = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        var viewType = (_b = (_a = props.organise) === null || _a === void 0 ? void 0 : _a.viewId) !== null && _b !== void 0 ? _b : "general";
        var tabs = [
            {
                id: "general",
                name: props.type === "list" ? "Table View" : "Card View",
                href: "".concat(props.localURLEndpoint, "?data=").concat(props.id, "&type=").concat(props.type, "&collection=").concat(props.collectionId, "&view=general"),
            },
        ];
        if (((_c = props.organise) === null || _c === void 0 ? void 0 : _c.extendedTabs) &&
            ((_d = props.organise.extendedTabs) === null || _d === void 0 ? void 0 : _d.length) > 0) {
            (_e = props.organise) === null || _e === void 0 ? void 0 : _e.extendedTabs.map(function (eachTab) {
                var hrefPoint = "".concat(props.localURLEndpoint, "?type=").concat(props.type, "&collection=").concat(props.collectionId);
                if (props.id)
                    hrefPoint += "&data=".concat(props.id);
                var id = (0, utils_1.lowercaseTextToId)(eachTab.name);
                var tabData = {
                    id: id,
                    name: eachTab.name,
                    href: hrefPoint + "&view=".concat(id),
                    type: eachTab.type,
                    viewType: eachTab.viewType,
                    viewImage: eachTab.viewImage,
                };
                if (eachTab.viewType === "iframe")
                    tabData["iframeSrc"] = eachTab.src;
                else
                    tabData["viewImage"] = eachTab.viewImage;
                if (eachTab.type === props.type) {
                    tabs.push(__assign(__assign({}, tabData), { del: (react_1.default.createElement(outline_1.XMarkIcon, { className: "'h-4 w-4 ml-2 text-red-600 hover:text-red-400", onClick: function (e) {
                                e.stopPropagation();
                                e.preventDefault();
                                handleDeleteTab(tabData.id);
                            } })) }));
                }
                return null;
            });
        }
        if (isEditor)
            tabs.push({
                id: "blixify_new_tab",
                name: "+ New Tab",
                href: "",
            });
        var pages = [
            {
                name: "Detail",
                href: "".concat(props.localURLEndpoint, "?type=list&collection=").concat(props.collectionId),
                current: false,
            },
        ];
        switch (props.type) {
            case "read":
                pages.push({
                    name: (_f = props.id) !== null && _f !== void 0 ? _f : "",
                    href: "#",
                    current: true,
                });
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(readQueryHoc_1.ReadQueryHoc, { ref: readQueryHocRef, database: {
                            dbModule: dbModule,
                            dbType: devSettings.server,
                            dbCollection: props.collectionId,
                            dbEndpoint: devSettings.dbEndpoint,
                            dbAPIToken: devSettings.dbAPIToken,
                        }, cond: {
                            type: "get",
                            id: props.id,
                        }, onChangeData: handleRetrieveSelectedData, onError: handleGetItemError }),
                    !loading && (react_1.default.createElement(react_1.default.Fragment, null,
                        props.breadcrumb && (react_1.default.createElement(breadcrumb_1.Breadcrumb, { pages: pages, linkType: props.linkType, custom: props.custom, className: "mb-5", onClick: handleBreadcrumbNavigate })),
                        react_1.default.createElement("div", null,
                            react_1.default.createElement("div", { className: "flex flex-col justify-between py-2 sm:items-center sm:flex-row" },
                                react_1.default.createElement("div", { className: "flex flex-col" },
                                    react_1.default.createElement("p", { className: "text-xl font-medium" }, props.title),
                                    react_1.default.createElement("span", { className: "text-sm text-gray-500" }, props.description)),
                                ((_g = props.edit) === null || _g === void 0 ? void 0 : _g.deleteBtn) && isEditor && (react_1.default.createElement("div", { className: "flex flex-col sm:flex-row" },
                                    react_1.default.createElement("div", { className: "w-full mt-5 ml-0 sm:mt-0 sm:ml-3" }, debug ? (react_1.default.createElement(button_1.Button, { text: "Update", className: "w-full", type: "normal", onClick: function () {
                                            var _a, _b;
                                            (_b = (_a = props.organise) === null || _a === void 0 ? void 0 : _a.debugOnChangeType) === null || _b === void 0 ? void 0 : _b.call(_a, "update", props.id);
                                        } })) : (react_1.default.createElement(link_1.Link, { className: "w-full", href: "".concat(props.localURLEndpoint, "?data=").concat(props.id, "&type=update&collection=").concat(props.collectionId, "&view=general"), linkType: props.linkType, custom: props.custom },
                                        react_1.default.createElement(button_1.Button, { text: "Update", className: "w-full", type: "normal" })))),
                                    react_1.default.createElement(button_1.Button, { text: "Delete", className: "mt-3 ml-0 sm:mt-0 sm:ml-3", type: "danger", onClick: function () {
                                            setDeleteModal(true);
                                        } }))))),
                        react_1.default.createElement(tabs_1.Tabs, { tabs: tabs, selectedId: viewType, linkType: props.linkType, custom: props.custom, onClick: function (id) {
                                if (id === "blixify_new_tab")
                                    handlePopUpModal(true, id);
                                else
                                    handleNavigate("".concat(props.localURLEndpoint, "?data=").concat(props.id, "&type=").concat(props.type, "&collection=").concat(props.collectionId, "&view=").concat(id));
                            } }),
                        renderTabContent(tabs, props.type, viewType)))));
            case "update":
                pages.push({
                    name: props.id ? props.id : "new",
                    href: "#",
                    current: true,
                });
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    props.id && props.id !== "new" && props.model.length > 1 && (react_1.default.createElement(readQueryHoc_1.ReadQueryHoc, { ref: readQueryHocRef, database: {
                            dbModule: dbModule,
                            dbType: devSettings.server,
                            dbCollection: props.collectionId,
                            dbEndpoint: devSettings.dbEndpoint,
                            dbAPIToken: devSettings.dbAPIToken,
                        }, cond: {
                            type: "get",
                            id: props.id,
                        }, onChangeData: handleRetrieveSelectedData, onError: handleGetItemError })),
                    props.breadcrumb && (react_1.default.createElement(breadcrumb_1.Breadcrumb, { pages: pages, linkType: props.linkType, custom: props.custom, className: "mb-5", onClick: handleBreadcrumbNavigate })),
                    react_1.default.createElement("div", { className: "flex flex-col justify-between py-2 sm:items-center sm:flex-row" },
                        react_1.default.createElement("div", { className: "flex flex-col" },
                            react_1.default.createElement("p", { className: "text-xl font-medium" }, props.title),
                            react_1.default.createElement("span", { className: "text-sm text-gray-500" }, props.description)),
                        ((_h = props.edit) === null || _h === void 0 ? void 0 : _h.deleteBtn) && isEditor && (react_1.default.createElement(button_1.Button, { text: "Delete", className: "mt-5 ml-0 sm:mt-0 sm:ml-5", type: "danger", onClick: function () {
                                setDeleteModal(true);
                            } }))),
                    react_1.default.createElement(form_1.Form, { className: "grid grid-cols-4 gap-6 mt-6", ref: formRef, refList: modalFormInputRefs, handleComplete: handleSubmit }, renderDataTemplateFormContent(selectedData, props.model, modalFormInputRefs, false, false)),
                    react_1.default.createElement("div", { className: "mt-8" }, renderListObject(props.type)),
                    react_1.default.createElement("div", { className: "flex justify-end pt-8" },
                        react_1.default.createElement(button_1.Button, { text: "Submit", type: "normal", onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                                var _a;
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0: return [4 /*yield*/, ((_a = formRef.current) === null || _a === void 0 ? void 0 : _a.handleSubmit())];
                                        case 1:
                                            _b.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); } }))));
            case "list":
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(readQueryHoc_1.ReadQueryHoc, { ref: readQueryHocRef, database: {
                            dbModule: dbModule,
                            dbType: devSettings.server,
                            dbCollection: props.collectionId,
                            dbEndpoint: devSettings.dbEndpoint,
                            dbAPIToken: devSettings.dbAPIToken,
                        }, cond: {
                            type: "list",
                            query: renderSearchFilterConditions(),
                            cursor: renderCursor(),
                            sort: (_k = (_j = props.organise) === null || _j === void 0 ? void 0 : _j.sort) !== null && _k !== void 0 ? _k : undefined,
                            limit: limit,
                        }, onChangeData: handleGetListData, onError: handleGetItemError }),
                    react_1.default.createElement("div", { className: "flex flex-col py-2 md:items-center md:flex-row" },
                        react_1.default.createElement("div", { className: "flex flex-col" },
                            react_1.default.createElement("p", { className: "text-xl font-medium" }, props.title),
                            react_1.default.createElement("span", { className: "text-sm text-gray-500" }, props.description)),
                        react_1.default.createElement("div", { className: "grow" }),
                        react_1.default.createElement("div", { className: "flex flex-col items-center justify-center mt-3 space-y-3 md:space-x-3 md:space-y-0 md:flex-row md:mt-0 md:mx-3" }, renderSearchFilterComponents()),
                        react_1.default.createElement("div", { className: "flex flex-row items-center mt-2 justify-content sm:mr-5 md:mt-0" },
                            react_1.default.createElement(iconButton_1.IconButton, { className: "bg-primary-100 mr-2", icon: react_1.default.createElement(solid_1.ArrowsUpDownIcon, { className: "h-7 w-7 text-primary-500" }), onClick: function () {
                                    handlePopUpModal(true, "sort");
                                } }),
                            react_1.default.createElement(iconButton_1.IconButton, { className: "bg-primary-100 mr-2", icon: react_1.default.createElement(outline_1.FunnelIcon, { className: "h-7 w-7 text-primary-500" }), onClick: function () {
                                    handlePopUpModal(true, "filter");
                                } }),
                            ((_l = props.organise) === null || _l === void 0 ? void 0 : _l.debugOnChangeType) ? (react_1.default.createElement(button_1.Button, { text: "Add", type: "normal", onClick: function () {
                                    var _a, _b;
                                    (_b = (_a = props.organise) === null || _a === void 0 ? void 0 : _a.debugOnChangeType) === null || _b === void 0 ? void 0 : _b.call(_a, "update", "new");
                                } })) : (react_1.default.createElement(link_1.Link, { className: "mr-2", href: "".concat(props.localURLEndpoint, "?data=new&type=update&collection=").concat(props.collectionId), linkType: props.linkType, custom: props.custom },
                                react_1.default.createElement(button_1.Button, { text: "Add", type: "normal" }))),
                            react_1.default.createElement(popUp_1.PopUp, { ctaComp: react_1.default.createElement(iconButton_1.IconButton, { className: "bg-primary-100", icon: react_1.default.createElement(solid_1.EllipsisVerticalIcon, { className: "h-7 w-7 text-primary-500" }) }), renderComp: react_1.default.createElement("div", { className: "shadow-lg" }, moreButtonPopUp.map(function (eachPopup) { return (
                                //TODO: Crash on Next Js
                                // <Menu.Item>
                                react_1.default.createElement("span", { className: "block w-40 py-3 text-sm text-center text-gray-700 cursor-pointer hover:bg-gray-100", onClick: eachPopup.onClick }, eachPopup.text)
                                // </Menu.Item>
                                ); })), lib: {
                                    Menu: (_m = props === null || props === void 0 ? void 0 : props.lib) === null || _m === void 0 ? void 0 : _m.Menu,
                                    Transition: (_o = props === null || props === void 0 ? void 0 : props.lib) === null || _o === void 0 ? void 0 : _o.Transition,
                                } }))),
                    react_1.default.createElement(tabs_1.Tabs, { tabs: tabs, selectedId: viewType, linkType: props.linkType, custom: props.custom, onClick: function (id) {
                            if (id === "blixify_new_tab") {
                                handlePopUpModal(true, id);
                            }
                            else {
                                handleNavigate("".concat(props.localURLEndpoint, "?data=").concat(props.id, "&type=").concat(props.type, "&collection=").concat(props.collectionId, "&view=").concat(id));
                            }
                        } }),
                    renderTabContent(tabs, props.type, viewType)));
            default:
                return react_1.default.createElement(react_1.default.Fragment, null);
        }
    };
    var renderSearchFilterConditions = function () {
        var _a, _b;
        var query = [];
        var searchQueryExist = false;
        (_b = (_a = props.organise) === null || _a === void 0 ? void 0 : _a.additionalQuery) === null || _b === void 0 ? void 0 : _b.map(function (eachSettings) {
            if (eachSettings.type === "list" && filterSelection) {
                var currentSelection = filterSelection;
                if (currentSelection === "false" || currentSelection === "true") {
                    currentSelection = currentSelection === "false" ? false : true;
                }
                else if (!isNaN(currentSelection)) {
                    currentSelection = Number(currentSelection);
                }
                query.push({
                    type: "=",
                    queryId: eachSettings.value,
                    value: currentSelection,
                });
            }
            else if (eachSettings.type === "reference" && filterReference)
                query.push({
                    type: "=",
                    queryId: eachSettings.value,
                    value: filterReference,
                });
            else if (eachSettings.type === "search") {
                searchQueryExist = true;
                if (filterSearchParams) {
                    query.push({
                        type: "search",
                        searchIds: [eachSettings.value],
                        value: filterSearchParams,
                    });
                }
            }
            else if (eachSettings.type === "range") {
                if (filterReferenceDate.startDate && filterReferenceDate.endDate) {
                    query.push({
                        type: "><",
                        queryId: eachSettings.value,
                        value: [
                            (0, moment_1.default)(filterReferenceDate.startDate).toISOString(),
                            (0, moment_1.default)(filterReferenceDate.endDate).toISOString(),
                        ],
                    });
                }
                else {
                    if (filterReferenceDate.startDate) {
                        query.push({
                            type: ">",
                            queryId: eachSettings.value,
                            value: (0, moment_1.default)(filterReferenceDate.startDate).toISOString(),
                        });
                    }
                    if (filterReferenceDate.endDate) {
                        query.push({
                            type: "<",
                            queryId: eachSettings.value,
                            value: (0, moment_1.default)(filterReferenceDate.endDate).toISOString(),
                        });
                    }
                }
            }
            return null;
        });
        if (!searchQueryExist &&
            devSettings.server === "mongoServer" &&
            filterSearchParams) {
            var searchKeys = props.model.map(function (eachAttribute) {
                if (eachAttribute.type === "address")
                    return eachAttribute.id + ".name";
                else
                    return eachAttribute.id;
            });
            query.push({
                type: "search",
                searchIds: searchKeys,
                value: filterSearchParams,
            });
        }
        return query.length > 0 ? query : undefined;
    };
    var renderSearchFilterComponents = function () {
        var _a, _b;
        var searchFilterList = [];
        var searchQueryExist = false;
        (_b = (_a = props.organise) === null || _a === void 0 ? void 0 : _a.additionalQuery) === null || _b === void 0 ? void 0 : _b.map(function (eachSettings) {
            var _a, _b, _c;
            switch (eachSettings.type) {
                case "list":
                    var filterOptions_2 = [];
                    (_a = eachSettings.options) === null || _a === void 0 ? void 0 : _a.map(function (eachValue) {
                        filterOptions_2.push({
                            key: eachValue,
                            label: eachValue,
                        });
                        return null;
                    });
                    searchFilterList.push(react_1.default.createElement(select_1.Select, { label: "", placeholder: "Filter by ".concat((0, utils_1.camelCaseToText)(eachSettings.value)), options: filterOptions_2, value: filterSelection, onChange: function (value) {
                            handleClearDataByFilter();
                            setFilterSelection(value);
                        } }));
                    break;
                case "reference":
                    var selectedModel_1 = props.model.find(function (eachDataStructure) { return eachDataStructure.id === eachSettings.value; });
                    searchFilterList.push(react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(readQueryHoc_1.ReadQueryHoc, { database: {
                                dbModule: dbModule,
                                dbType: devSettings.server,
                                dbCollection: (_b = selectedModel_1 === null || selectedModel_1 === void 0 ? void 0 : selectedModel_1.referenceSpaceId) !== null && _b !== void 0 ? _b : "",
                                dbEndpoint: devSettings.dbEndpoint,
                                dbAPIToken: devSettings.dbAPIToken,
                            }, cond: {
                                type: "list",
                                limit: limit,
                                query: filterReferenceSearch
                                    ? [
                                        {
                                            type: "search",
                                            searchIds: [(_c = selectedModel_1 === null || selectedModel_1 === void 0 ? void 0 : selectedModel_1.referenceLabel) !== null && _c !== void 0 ? _c : ""],
                                            value: filterReferenceSearch,
                                        },
                                    ]
                                    : undefined,
                            }, onChangeData: function (data) {
                                if (data.data) {
                                    var options_1 = [];
                                    data.data.map(function (eachData) {
                                        var _a, _b;
                                        var eachDataId = eachData._id
                                            ? eachData._id
                                            : eachData.id;
                                        options_1.push({
                                            key: eachDataId,
                                            label: (_b = eachData[(_a = selectedModel_1 === null || selectedModel_1 === void 0 ? void 0 : selectedModel_1.referenceLabel) !== null && _a !== void 0 ? _a : ""]) !== null && _b !== void 0 ? _b : "",
                                        });
                                        return null;
                                    });
                                    setFilterReferenceList(options_1);
                                }
                            } }),
                        react_1.default.createElement(select_1.Select, { label: "", placeholder: "Filter by ".concat((0, utils_1.camelCaseToText)(eachSettings.value)), options: filterReferenceList, value: filterReference, onChange: function (value) {
                                handleClearDataByFilter();
                                setFilterReference(value);
                            }, onSearch: function (value) {
                                setFilterReferenceSearch(value);
                            } })));
                    break;
                case "search":
                    searchQueryExist = true;
                    searchFilterList.push(react_1.default.createElement(textInput_1.TextInput, { containerClassName: "w-full", placeholder: "Search by ".concat(eachSettings.value), label: "", type: "text", value: filterSearch, onChange: handleNameSearch }));
                    break;
                case "range":
                    searchFilterList.push(react_1.default.createElement("div", { className: "pb-0 md:pb-5 w-full" },
                        react_1.default.createElement(datePicker_1.InputDatePicker, { id: "startDate", startDate: filterReferenceDate.startDate, endDate: filterReferenceDate.endDate, range: true, onChange: handleRangeFilterOnChange, showTime: true })));
                    break;
            }
            return null;
        });
        if (!searchQueryExist && devSettings.server === "mongoServer") {
            searchFilterList.push(react_1.default.createElement(textInput_1.TextInput, { containerClassName: "w-full", placeholder: "Search", label: "", type: "text", value: filterSearch, onChange: handleNameSearch }));
        }
        return searchFilterList;
    };
    //=====================================================================================
    //SECTION: Render Utils
    //=====================================================================================
    var renderDataTemplateFormContent = function (state, model, ref, isObject, isObjectList, modalInput) {
        var _a, _b, _c, _d;
        return (0, display_1.renderDataTemplateForm)(state, model, ref, {
            handleOnChangeAddress: handleOnChangeAddress,
            handleOnChangeText: handleOnChangeText,
            handleOnChangeSelect: handleOnChangeSelect,
            handleOnChangeDate: handleOnChangeDate,
            handleOnChangeFile: handleOnChangeFile,
            handleOnChangeFiles: handleOnChangeFiles,
            handleOnChangeMarkdown: handleOnChangeMarkdown,
        }, modalInput, undefined, {
            id: props.id,
            isObject: isObject,
            isObjectList: isObjectList,
            lib: { axios: (_a = props.lib) === null || _a === void 0 ? void 0 : _a.axios },
            type: props.type,
        }, {
            dbModule: dbModule,
            server: (_b = devSettings.server) !== null && _b !== void 0 ? _b : "mongoServer",
            dbEndpoint: (_c = devSettings.dbEndpoint) !== null && _c !== void 0 ? _c : "",
            dbApiToken: (_d = devSettings.dbAPIToken) !== null && _d !== void 0 ? _d : "",
            referencesOptions: referencesOptions,
            referenceLoading: referenceLoading,
            setReferenceLoading: setReferenceLoading,
            setReferencesOptions: setReferencesOptions,
        }, {
            imageEndpoint: devSettings.imageEndpoint,
            maxFileSize: devSettings.maxFileSize,
        }, {
            selectedObjectId: selectedObjectId,
            selectedObjectStructureId: selectedObjectStructureId,
            setSelectedObjectStructureId: setSelectedObjectStructureId,
            setSelectedObjectData: setSelectedObjectData,
            handlePopUpModal: handlePopUpModal,
            renderObjectTags: renderObjectTags,
        });
    };
    var renderGridAndListData = function (imageTag, type) {
        var gridData = [];
        spaceTableData.forEach(function (eachData) {
            var _a, _b;
            var clonedEachData = JSON.parse(JSON.stringify(eachData));
            var allValues = Object.values(clonedEachData);
            var titleIndex = 1;
            var title = allValues.length > 0
                ? (0, display_1.renderEachRowDataBasedOnDataType)(allValues[titleIndex]) !== " - "
                    ? (0, display_1.renderEachRowDataBasedOnDataType)(allValues[titleIndex])
                    : ""
                : "";
            var desc = "";
            Object.entries(eachData).forEach(function (value) {
                var eachKey = value[0], eachValue = value[1];
                var selectedModel = props.model.find(function (eachModel) { return eachModel.id === eachKey; });
                if (eachKey === "_id" ||
                    eachKey === "id" ||
                    eachKey === "baseUpdatedAt" ||
                    eachKey === "baseDraft" ||
                    eachKey === "update" ||
                    !selectedModel ||
                    selectedModel.type === "object" ||
                    selectedModel.type === "listObject" ||
                    selectedModel.type === "file" ||
                    selectedModel.type === "multipleFile" ||
                    selectedModel.type === "multipleImage" ||
                    eachKey === imageTag ||
                    eachValue === title) {
                    return null;
                }
                desc += "".concat((0, utils_1.camelCaseToText)(eachKey), " : ").concat((0, display_1.renderEachRowDataBasedOnDataType)(eachValue), " \n");
                return null;
            });
            var data = {
                id: clonedEachData["id"],
                title: title,
                description: desc,
            };
            data[type === "grid" ? "imageUrl" : "img"] = clonedEachData[imageTag]
                ? (_b = (_a = clonedEachData[imageTag]) === null || _a === void 0 ? void 0 : _a.props) === null || _b === void 0 ? void 0 : _b.src
                : "";
            gridData.push(data);
        });
        return gridData;
    };
    var renderTabContent = function (tabs, dataType, viewType) {
        var _a, _b, _c, _d, _e, _f, _g;
        var selectedTabData = tabs.find(function (eachTab) {
            if (eachTab.id === viewType) {
                return eachTab;
            }
            else {
                return null;
            }
        });
        if (viewType === "general") {
            if (dataType === "list") {
                return (react_1.default.createElement(table_1.Table, { paginationType: devSettings.server === "mongoServer" ? "page" : "cursor", data: tableData, space: props.space, spaceData: spaceTableData, size: size, limit: limit, cursor: cursor, loading: tableLoading, checkbox: isEditor ? true : false, selectAll: selectAll, selectedIds: selectedIds, selectAllText: selectAll ? "from filter" : "", multiActionButton: react_1.default.createElement("div", { className: "flex flex-row space-x-3" },
                        react_1.default.createElement(textButton_1.TextButton, { className: "text-sm text-red-500 hover:text-red-600", text: "Delete", onClick: function () {
                                handleGenerateDeletePasscode();
                                setDeleteModal(true);
                            } }),
                        !selectAll && (react_1.default.createElement(textButton_1.TextButton, { className: "text-sm", text: "Update", onClick: function () {
                                setBatchUpdateModal(true);
                            } }))), handleSelectAll: handleSelectAllPages, handleSelectedIds: handleSelectIds, header: renderTableHeader(), pageIndex: pageIndex, onClickRow: function (id) {
                        var _a;
                        if ((_a = props.organise) === null || _a === void 0 ? void 0 : _a.debugOnChangeType)
                            props.organise.debugOnChangeType("read", id);
                        else
                            handleNavigate("".concat(props.localURLEndpoint, "?data=").concat(id, "&type=read&collection=").concat(props.collectionId, "&view=general"));
                    }, linkType: props.linkType, custom: props.custom, newTabUrl: "".concat(props.localURLEndpoint, "?data="), addNewTabUrl: "&type=read&collection=".concat(props.collectionId, "&view=general"), handleUpdatePageIndex: handlePagination, className: "mt-5", lib: { axios: (_a = props.lib) === null || _a === void 0 ? void 0 : _a.axios }, devSettings: {
                        schemaEndpoint: devSettings.schemaEndpoint,
                        server: devSettings.server,
                        dbEndpoint: devSettings.dbEndpoint,
                        dbAPIToken: devSettings.dbAPIToken,
                        imageEndpoint: devSettings.imageEndpoint,
                    }, editable: {
                        active: ((_b = props.edit) === null || _b === void 0 ? void 0 : _b.listEditable) ? true : false,
                        onUpdateData: function (rowId, columnId, data) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, handleSubmitData("update", rowId, columnId, data)];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); },
                    }, addable: {
                        active: ((_c = props.edit) === null || _c === void 0 ? void 0 : _c.listAddable) ? true : false,
                        onAddData: function (data) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, handleSubmitData("create", "", "", data)];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); },
                    } }));
            }
            else if (dataType === "read") {
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(detailList_1.DetailList, { lib: {
                            Dialog: (_d = props.lib) === null || _d === void 0 ? void 0 : _d.Dialog,
                            Transition: (_e = props.lib) === null || _e === void 0 ? void 0 : _e.Transition,
                        }, model: props.model, referenceModel: referenceModelSchema, className: "mt-5 bg-white rounded-md", title: "General Details", list: renderDetailListData() }),
                    react_1.default.createElement("div", { className: "mt-8" }, renderListObject(dataType))));
            }
        }
        else if (selectedTabData) {
            if (selectedTabData.viewType === "iframe") {
                return (react_1.default.createElement("iframe", { className: "w-full mt-5", style: { height: "70vh" }, src: (_f = selectedTabData === null || selectedTabData === void 0 ? void 0 : selectedTabData.iframeSrc) !== null && _f !== void 0 ? _f : "", title: (_g = selectedTabData === null || selectedTabData === void 0 ? void 0 : selectedTabData.id) !== null && _g !== void 0 ? _g : "" }));
            }
            else if (selectedTabData.viewType === "list") {
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(list_1.List, { paginationType: devSettings.server === "mongoServer" ? "page" : "cursor", list: renderGridAndListData(selectedTabData.viewImage, "list"), size: size, limit: limit, cursor: cursor, loading: tableLoading, pageIndex: pageIndex, onClickRow: function (id) {
                            var _a;
                            if ((_a = props.organise) === null || _a === void 0 ? void 0 : _a.debugOnChangeType)
                                props.organise.debugOnChangeType("read", id);
                            else
                                handleNavigate("".concat(props.localURLEndpoint, "?data=").concat(id, "&type=read&collection=").concat(props.collectionId, "&view=general"));
                        }, linkType: props.linkType, custom: props.custom, newTabUrl: "".concat(props.localURLEndpoint, "?data="), addNewTabUrl: "&type=read&collection=".concat(props.collectionId, "&view=general"), handleUpdatePageIndex: handlePagination, className: "mt-5" })));
            }
            else if (selectedTabData.viewType === "grid") {
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(grid_1.Grid, { paginationType: devSettings.server === "mongoServer" ? "page" : "cursor", data: renderGridAndListData(selectedTabData.viewImage, "grid"), size: size, limit: limit, cursor: cursor, loading: tableLoading, pageIndex: pageIndex, onClickData: function (id) {
                            var _a;
                            if ((_a = props.organise) === null || _a === void 0 ? void 0 : _a.debugOnChangeType)
                                props.organise.debugOnChangeType("read", id);
                            else
                                handleNavigate("".concat(props.localURLEndpoint, "?data=").concat(id, "&type=read&collection=").concat(props.collectionId, "&view=general"));
                        }, linkType: props.linkType, custom: props.custom, newTabUrl: "".concat(props.localURLEndpoint, "?data="), addNewTabUrl: "&type=read&collection=".concat(props.collectionId, "&view=general"), handleUpdatePageIndex: handlePagination, className: "mt-5" })));
            }
            else if (selectedTabData.renderComp) {
                return react_1.default.createElement(react_1.default.Fragment, null, selectedTabData.renderComp());
            }
        }
        return null;
    };
    var renderNotification = function (location) {
        var _a;
        if (notification) {
            var correctIcon = (react_1.default.createElement(outline_1.CheckCircleIcon, { className: "w-10 h-10 text-primary-600" }));
            var incorrectIcon = (react_1.default.createElement(outline_1.XCircleIcon, { className: "w-10 h-10 text-primary-600" }));
            if (location === "modal" && !modalVisible)
                return null;
            if (location === "root" && modalVisible)
                return null;
            return (react_1.default.createElement(notification_1.Notification, { icon: notification.type ? correctIcon : incorrectIcon, notificationAttribute: {
                    title: notification.title,
                    desc: notification.msg,
                    visible: true,
                }, lib: {
                    Transition: (_a = props.lib) === null || _a === void 0 ? void 0 : _a.Transition,
                }, onClose: function () {
                    setNotification(null);
                    return "";
                } }));
        }
        return null;
    };
    var renderModalContent = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        if (loading) {
            return (react_1.default.createElement("div", { className: "mt-5" },
                react_1.default.createElement(loading_1.Loading, null),
                react_1.default.createElement("div", { className: "mt-3 text-center sm:mt-5" },
                    react_1.default.createElement("h3", { className: "text-lg font-medium leading-6 text-gray-900", id: "modal-title" }, "Loading"),
                    react_1.default.createElement("div", { className: "mt-2" },
                        react_1.default.createElement("p", { className: "text-sm text-gray-500" }, "Please wait while we are proccessing your request")))));
        }
        else if (excelModal) {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                stepCSVIndex >= 0 && stepCSVIndex < 3 && (react_1.default.createElement("div", null,
                    react_1.default.createElement(stepper_1.Stepper, { steps: [
                            {
                                title: "Select a file",
                            },
                            {
                                title: "Map Column Data",
                            },
                            {
                                title: "Review and Upload",
                            },
                        ], className: "mt-5", horizontal: true, stepIndex: stepCSVIndex, onChange: function () { }, disabled: true }))),
                react_1.default.createElement("div", { className: "mt-5" }, renderStepCSV()),
                react_1.default.createElement("div", { className: "flex justify-end mt-5" }, importTableData.length > 0 ? (react_1.default.createElement(button_1.Button, { text: "Close", type: "normal", onClick: function () {
                        handlePopUpModal(false);
                    } })) : (react_1.default.createElement(react_1.default.Fragment, null,
                    stepCSVIndex > 0 && (react_1.default.createElement(button_1.Button, { className: "flex justify-end mr-10", text: "Back", type: "normal", onClick: function () {
                            setStepCSVIndex(stepCSVIndex - 1);
                        } })),
                    react_1.default.createElement(button_1.Button, { text: "".concat(stepCSVIndex < 2 ? "Next" : "Submit"), type: "normal", onClick: handleStepCSV }))))));
        }
        else if (exportExcel) {
            return (react_1.default.createElement(react_1.default.Fragment, null, exportLink ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(emptyState_1.EmptyState, { icon: react_1.default.createElement(outline_1.CheckCircleIcon, { className: "w-20 h-20 text-primary-600" }), text: "Data have been successfully exported, click on the download link below", callToAction: react_1.default.createElement("div", null,
                        react_1.default.createElement(link_1.Link, { href: exportLink },
                            react_1.default.createElement(button_1.Button, { text: "Download", type: "normal", size: "small" }))) }))) : (react_1.default.createElement(react_1.default.Fragment, null, queryForm ? (react_1.default.createElement(queryForm_1.QueryForm, { dbModule: (_a = props.lib) === null || _a === void 0 ? void 0 : _a.axios, model: props.model, updateQuery: queryIndex >= 0 ? queryList[queryIndex] : undefined, devSettings: {
                    schemaEndpoint: props.devSettings.schemaEndpoint,
                    server: props.devSettings.server,
                    dbEndpoint: props.devSettings.dbEndpoint,
                    dbAPIToken: props.devSettings.dbAPIToken,
                    imageEndpoint: props.devSettings.imageEndpoint,
                    uploadEndpoint: props.devSettings.uploadEndpoint,
                    bucketName: props.devSettings.bucketName,
                }, handleCloseForm: function () {
                    handleViewQuery(-1);
                }, handleQueryOnComplete: function (queryData) {
                    handlePushQueryList(queryData, queryIndex);
                }, renderReferenceLabelOptions: ((_b = props.organise) === null || _b === void 0 ? void 0 : _b.renderReferenceLabelOptions)
                    ? (_c = props.organise) === null || _c === void 0 ? void 0 : _c.renderReferenceLabelOptions
                    : function () {
                        return [];
                    } })) : (react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: "" },
                    react_1.default.createElement("p", { className: "pt-2 mb-4 text-sm text-gray-600" }, "Export your data to .csv format to be viewable on Excel. Filter your data exported based on conditions by creating queries at the table below"),
                    react_1.default.createElement("div", { className: "flex items-center justify-end" },
                        react_1.default.createElement(iconButton_1.IconButton, { className: "sm", icon: react_1.default.createElement(outline_1.PlusCircleIcon, { className: "w-6 h-6 text-white" }), background: "bg-primary-500 hover:bg-primary-600", onClick: function () { return setQueryForm(!queryForm); } }))),
                react_1.default.createElement(table_1.Table, { className: "mt-5", header: queryTableHeader, data: renderQueryData(), loading: false }),
                react_1.default.createElement("div", { className: "flex justify-end mt-5 " },
                    react_1.default.createElement(button_1.Button, { className: "mt-4", text: "Submit", size: "small", type: "normal", onClick: handleExportCSVData }))))))));
        }
        else if (sortModal) {
            return (react_1.default.createElement(settingsModal_1.SortModal, { sort: (_d = props.organise) === null || _d === void 0 ? void 0 : _d.sort, onChangeSort: (_e = props.organise) === null || _e === void 0 ? void 0 : _e.onChangeSort, renderReferenceLabelOptions: (_f = props.organise) === null || _f === void 0 ? void 0 : _f.renderReferenceLabelOptions, onClose: function () {
                    handlePopUpModal(false);
                } }));
        }
        else if (filterModal) {
            return (react_1.default.createElement(settingsModal_1.FilterModal, { server: props.devSettings.server, filter: (_g = props.organise) === null || _g === void 0 ? void 0 : _g.additionalQuery, onChangeFilter: (_h = props.organise) === null || _h === void 0 ? void 0 : _h.onChangeFilter, renderReferenceLabelOptions: (_j = props.organise) === null || _j === void 0 ? void 0 : _j.renderReferenceLabelOptions, renderReferenceSpaceOptions: (_k = props.organise) === null || _k === void 0 ? void 0 : _k.renderReferenceSpaceOptions, setNotification: setNotification, onClose: function () {
                    handlePopUpModal(false);
                } }));
        }
        else if (addTabModal) {
            return (react_1.default.createElement(settingsModal_1.TabModal, { type: props.type, tabs: (_l = props.organise) === null || _l === void 0 ? void 0 : _l.extendedTabs, onChangeTabs: (_m = props.organise) === null || _m === void 0 ? void 0 : _m.onChangeTabs, renderReferenceLabelOptions: (_o = props.organise) === null || _o === void 0 ? void 0 : _o.renderReferenceLabelOptions, onClose: function () {
                    handlePopUpModal(false);
                } }));
        }
        else {
            var filterObjectModel = props.model.find(function (eachModel) {
                return eachModel.id === selectedObjectStructureId;
            });
            if (filterObjectModel === null || filterObjectModel === void 0 ? void 0 : filterObjectModel.objectData) {
                var objectFormInputRefs = filterObjectModel.objectData.map(function () {
                    return (0, react_1.createRef)();
                });
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(form_1.Form, { className: "grid grid-cols-4 gap-6 pb-20 mt-6", ref: objectFormRef, refList: objectFormInputRefs, handleComplete: handleSubmitObjectDataType }, renderDataTemplateFormContent(selectedObjectData, (_p = filterObjectModel === null || filterObjectModel === void 0 ? void 0 : filterObjectModel.objectData) !== null && _p !== void 0 ? _p : [], objectFormInputRefs, true, filterObjectModel.type === "listObject")),
                    react_1.default.createElement("div", { className: "flex justify-end pt-8" },
                        filterObjectModel.type === "listObject" &&
                            selectedObjectId &&
                            props.type !== "read" && (react_1.default.createElement(button_1.Button, { className: "mr-5", text: "Delete", type: "danger", onClick: handleRemoveObjectListData })),
                        react_1.default.createElement(button_1.Button, { text: "".concat(props.type === "read" ? "Close" : "Submit"), type: "normal", onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                                var _a;
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0: return [4 /*yield*/, ((_a = objectFormRef.current) === null || _a === void 0 ? void 0 : _a.handleSubmit())];
                                        case 1:
                                            _b.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); } }))));
            }
            else {
                return react_1.default.createElement(react_1.default.Fragment, null);
            }
        }
    };
    var renderDeleteModalContent = function () {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "px-3 sm:px-0" },
                react_1.default.createElement("div", { className: "flex" },
                    react_1.default.createElement("h2", { className: "mt-2 mb-2 text-xl font-bold text-gray-900" }, "Delete Confirmation")),
                react_1.default.createElement("p", { className: "mt-2 mb-4" },
                    "Are you sure you want to permanently delete",
                    " ",
                    props.type === "list" ? "these" : "this",
                    " data?"),
                props.type === "list" && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("p", { className: "mb-2" },
                        "Enter passcode",
                        " ",
                        react_1.default.createElement("span", { className: "font-semibold" }, deletePasscode),
                        " to delete."),
                    react_1.default.createElement(textInput_1.TextInput, { label: "", value: deletePasscodeInput, onChange: function (e) { return setDeletePasscodeInput(e.target.value); }, type: "password", placeholder: "Type your passcode here" }))),
                react_1.default.createElement("div", { className: "flex flex-row justify-end pt-5 mt-6 space-x-2" },
                    react_1.default.createElement(button_1.Button, { text: "Close", size: "small", type: "light", onClick: function () {
                            setDeletePasscodeInput("");
                            setDeleteModal(false);
                        } }),
                    react_1.default.createElement(button_1.Button, { text: "Delete", size: "small", type: "danger", onClick: function () {
                            if (props.type === "list") {
                                handleMultipleRemoveSelectedData();
                            }
                            else {
                                handleRemoveSelectedData();
                            }
                        } })))));
    };
    var renderBatchUpdateModalContent = function () {
        var _a;
        if (batchUpdateModal) {
            var unsupportedModelType_1 = [
                "object",
                "listObject",
                "multipleFile",
                "multipleImage",
                "markdown",
            ];
            var columnIdOptions = props.model
                .filter(function (eachModel) {
                return eachModel.id !== "id" &&
                    !eachModel.unique &&
                    !eachModel.disabled &&
                    !unsupportedModelType_1.includes(eachModel.type);
            })
                .map(function (eachModel) { return ({ key: eachModel.id, label: eachModel.name }); });
            var defaultModel = {
                id: "text",
                name: "Value",
                disabled: true,
                type: "string",
            };
            var modelFound = props.model.find(function (eachModel) { return eachModel.id === batchUpdateData.columnId; });
            var model = modelFound !== null && modelFound !== void 0 ? modelFound : defaultModel;
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(form_1.Form, { ref: batchUpdateFormRef, refList: [batchUpdateColumnIdRef, batchUpdateInputRef], handleComplete: handleBatchUpdateData },
                    react_1.default.createElement(select_1.Select, { ref: batchUpdateColumnIdRef, id: "columnId", value: (_a = batchUpdateData.columnId) !== null && _a !== void 0 ? _a : "", label: "Column ID", options: columnIdOptions, onChange: function (value) {
                            var _a;
                            setBatchUpdateData({
                                columnId: value,
                                columnData: (_a = {}, _a[value] = undefined, _a),
                            });
                        }, containerClassName: "mb-6", staticDropdown: true }),
                    renderDataTemplateFormContent(batchUpdateData.columnData, [model], [batchUpdateInputRef], false, false, true)),
                react_1.default.createElement("div", { className: "flex flex-row justify-end pt-5 mt-6 space-x-2" },
                    react_1.default.createElement(button_1.Button, { text: "Close", size: "small", type: "light", onClick: function () {
                            setBatchUpdateData({ columnId: "", columnData: {} });
                            setBatchUpdateModal(false);
                        } }),
                    react_1.default.createElement(button_1.Button, { text: "Update", size: "small", type: "normal", onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, batchUpdateFormRef.current.handleSubmit()];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); } }))));
        }
        else
            return null;
    };
    var renderModalTitle = function () {
        if (excelModal)
            return "Import CSV";
        else if (exportExcel)
            return "Export CSV";
        else if (sortModal)
            return "Sort Data";
        else if (filterModal)
            return "Slice Data";
        else if (addTabModal)
            return "Add Tab";
        else
            return "";
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        renderNotification("root"),
        react_1.default.createElement(modal_1.Modal, { maxWidth: selectedObjectStructureId || excelModal ? "2xl" : undefined, open: modalVisible, title: renderModalTitle(), lib: { Dialog: (_g = props.lib) === null || _g === void 0 ? void 0 : _g.Dialog, Transition: (_h = props.lib) === null || _h === void 0 ? void 0 : _h.Transition }, renderContent: renderModalContent, onClose: function () {
                if (queryForm)
                    handleViewQuery(-1);
                else
                    handlePopUpModal(false);
            }, notification: react_1.default.createElement(react_1.default.Fragment, null, renderNotification("modal")) }),
        react_1.default.createElement(modal_1.Modal, { open: deleteModal, lib: { Dialog: (_j = props.lib) === null || _j === void 0 ? void 0 : _j.Dialog, Transition: (_k = props.lib) === null || _k === void 0 ? void 0 : _k.Transition }, renderContent: renderDeleteModalContent, onClose: function () {
                setDeletePasscodeInput("");
                setDeleteModal(!deleteModal);
            }, notification: react_1.default.createElement(react_1.default.Fragment, null, renderNotification("modal")) }),
        react_1.default.createElement(modal_1.Modal, { open: batchUpdateModal, lib: { Dialog: (_l = props.lib) === null || _l === void 0 ? void 0 : _l.Dialog, Transition: (_m = props.lib) === null || _m === void 0 ? void 0 : _m.Transition }, renderContent: renderBatchUpdateModalContent, onClose: function () {
                setBatchUpdateData({ columnId: "", columnData: {} });
                setBatchUpdateModal(false);
            }, notification: react_1.default.createElement(react_1.default.Fragment, null, renderNotification("modal")) }),
        renderContent()));
}
exports.DataTemplate = DataTemplate;
//# sourceMappingURL=index.js.map